/* eslint @kadena-dev/typedef-var: "off" */
  export const menuData = [
  {
    "children": [
      {
        "children": [],
        "root": "/docs/kadena/overview",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Overview of Kadena",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "Kadena",
        "label": "Overview",
        "order": 1,
        "layout": "full",
        "wordCount": 745,
        "readingTimeInMinutes": 4,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": false
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/kadena/kda/manage-kda",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Manage KDA",
            "description": "Manage KDA",
            "menu": "Manage KDA",
            "label": "Manage KDA",
            "order": 2,
            "layout": "full",
            "wordCount": 258,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/kda/kda-concepts",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "KDA Concepts",
            "description": "KDA Concepts",
            "menu": "KDA Concepts",
            "label": "KDA Concepts",
            "order": 2,
            "layout": "full",
            "wordCount": 771,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/kadena/kda",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "What is KDA?",
        "description": "Digital currency that is used to pay for compute on the Kadena public chain.",
        "menu": "KDA",
        "label": "What is KDA?",
        "order": 3,
        "layout": "full",
        "wordCount": 247,
        "readingTimeInMinutes": 2,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/kadena/whitepapers/chainweb-layer-1",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Chainweb Layer 1",
            "description": "Kadena's public blockchain, Chainweb, is the only sharded and scalable layer-1 PoW network",
            "menu": "Whitepapers",
            "label": "Chainweb Layer 1",
            "order": 2,
            "layout": "full",
            "wordCount": 172,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/whitepapers/pact-smart-contract-language",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact Smart Contract Language",
            "description": "Pact makes designing safer smart contracts effortless, whether you’re writing your first contract or launching your fiftieth dApp. It’s fundamentally different from other contract languages. It’s readable by non-developers. It automatically detects bugs, freeing you from the exploits you’ll face on Ethereum and other unsafe platforms. And it has been battle-tested in production applications for over two years.",
            "menu": "Whitepapers",
            "label": "Pact Smart Contract",
            "order": 3,
            "layout": "full",
            "wordCount": 166,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/whitepapers/kuro-layer-2",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kuro Layer 2",
            "description": "Kuro has been proven to support up to 8,000 transactions per second across 500 nodes, and is available for evaluation on AWS and Azure. Lightning+BTC powers El Salvador, but Chainweb's layer 1 scalability and Kuro's near instant finality can power the whole world.",
            "menu": "Whitepapers",
            "label": "Kuro Layer 2",
            "order": 4,
            "layout": "full",
            "wordCount": 130,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/kadena/whitepapers",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Whitepapers Overview",
        "description": "Answers to commonly asked questions about Kadena.",
        "menu": "Whitepapers",
        "label": "Overview",
        "order": 4,
        "layout": "full",
        "wordCount": 456,
        "readingTimeInMinutes": 3,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [
              {
                "children": [],
                "root": "/docs/kadena/wallets/chainweaver/chainweaver-troubleshooting",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Troubleshooting Chainweaver",
                "description": "Troubleshooting Chainweaver",
                "menu": "Chainweaver",
                "label": "Troubleshooting",
                "order": 3,
                "layout": "full",
                "wordCount": 404,
                "readingTimeInMinutes": 3,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/kadena/wallets/chainweaver/terms-of-service",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Chainweaver Terms of Service",
                "description": "Chainweaver Terms of Service",
                "menu": "Chainweaver",
                "label": "Terms of Service",
                "order": 4,
                "layout": "full",
                "wordCount": 4138,
                "readingTimeInMinutes": 21,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              }
            ],
            "root": "/docs/kadena/wallets/chainweaver",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Chainweaver User Guide",
            "description": "Chainweaver User Guide",
            "menu": "Chainweaver",
            "label": "User Guide",
            "order": 2,
            "layout": "full",
            "wordCount": 4312,
            "readingTimeInMinutes": 22,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          },
          {
            "children": [],
            "root": "/docs/kadena/wallets/ledger",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Ledger User Guide",
            "description": "Ledger User Guide",
            "menu": "Ledger",
            "label": "Ledger User Guide",
            "order": 3,
            "layout": "full",
            "wordCount": 429,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/kadena/wallets",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Kadena Wallets",
        "description": "KDA custody tools for desktop and mobile, with support guides to get you started.",
        "menu": "Kadena Wallets",
        "label": "Overview",
        "order": 4,
        "layout": "full",
        "wordCount": 390,
        "readingTimeInMinutes": 2,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [],
        "root": "/docs/kadena/exchanges",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Kadena Exchanges",
        "description": "A summary of the key features supported by the exchanges trading KDA.",
        "menu": "Exchanges",
        "label": "Exchanges",
        "order": 4,
        "layout": "full",
        "wordCount": 489,
        "readingTimeInMinutes": 3,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": false
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/kadena/support/developer-program",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Developer Program",
            "description": "Exclusive resources and support for you to build your best dApp.",
            "menu": "Support",
            "label": "Developer Program",
            "order": 2,
            "layout": "full",
            "wordCount": 394,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/support/technical-grants",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Technical Grants",
            "description": "Get rewarded for your contributions to the growth of Kadena.",
            "menu": "Support",
            "label": "Technical Grants",
            "order": 3,
            "layout": "full",
            "wordCount": 35,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/kadena/support",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "FAQ",
        "description": "Answers to commonly asked questions about Kadena.",
        "menu": "Support",
        "label": "FAQ",
        "order": 5,
        "layout": "full",
        "wordCount": 609,
        "readingTimeInMinutes": 4,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/kadena/kadenajs/todo",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "TODO",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "TODO",
            "label": "TODO",
            "order": 1,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/kadena.js/README.md",
            "layout": "full",
            "tags": [
              "run tests",
              "pact server"
            ],
            "wordCount": 1079,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/kadena/kadenajs",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Running Tests",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "KadenaJS",
        "label": "Running Tests",
        "order": 6,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/kadena.js/README.md",
        "layout": "full",
        "tags": [
          "run tests",
          "pact server"
        ],
        "wordCount": 155,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/kadena/resources/press-kit",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Press Kit",
            "description": "Our ecosystem is growing rapidly, so we are now providing access to our branding assets that are available and approved for public use.",
            "menu": "Kadena",
            "label": "Press Kit",
            "order": 2,
            "layout": "full",
            "wordCount": 102,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/resources/glossary",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Glossary",
            "description": "General and specific terminology related to Kadena.",
            "menu": "Kadena",
            "label": "Glossary",
            "order": 3,
            "layout": "full",
            "wordCount": 1510,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/resources/kadena-content-repository",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Content Repo",
            "description": "Explore our collection of articles, written pieces, podcasts and more to get you up to speed on all things Kadena and beyond.",
            "label": "Content Repo",
            "order": 4,
            "layout": "full",
            "wordCount": 110,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/kadena/resources",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Kadena Resources",
        "description": "Here are the official links for Kadena's social pages, blog, and developer resources",
        "menu": "Resources",
        "label": "Resources",
        "order": 7,
        "layout": "full",
        "wordCount": 118,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/kadena/client/prerequisites",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Prerequisites",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Prerequisites",
            "label": "Prerequisites",
            "order": 1,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client"
            ],
            "wordCount": 104,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/client/contractbased-interaction-using-kadenaclient",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Contract-based interaction using @kadena/client",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Contract-based interaction using @kadena/client",
            "label": "Contract-based interaction using @kadena/client",
            "order": 2,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client"
            ],
            "wordCount": 444,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/client/building-a-simple-transaction-from-the-contract",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Building a simple transaction from the contract",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Building a simple transaction from the contract",
            "label": "Building a simple transaction from the contract",
            "order": 3,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client"
            ],
            "wordCount": 342,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/client/signing",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Signing",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Signing",
            "label": "Signing",
            "order": 4,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client"
            ],
            "wordCount": 307,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/client/using-the-commandbuilder",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Using the commandBuilder",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Using the commandBuilder",
            "label": "Using the commandBuilder",
            "order": 5,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client"
            ],
            "wordCount": 166,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/client/using-fp-approach",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Using FP approach",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Using FP approach",
            "label": "Using FP approach",
            "order": 6,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client"
            ],
            "wordCount": 152,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/client/send-a-request-to-the-blockchain",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Send a request to the blockchain",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Send a request to the blockchain",
            "label": "Send a request to the blockchain",
            "order": 7,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client"
            ],
            "wordCount": 334,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/client/upgrading-from-kadenaclient-0x-to-100",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Upgrading from @kadena/client 0.x to 1.0.0",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Upgrading from @kadena/client 0.x to 1.0.0",
            "label": "Upgrading from @kadena/client 0.x to 1.0.0",
            "order": 8,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client"
            ],
            "wordCount": 555,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/client/further-development",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Further development",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Further development",
            "label": "Further development",
            "order": 9,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client"
            ],
            "wordCount": 98,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/client/contact-the-team",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Contact the team",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Contact the team",
            "label": "Contact the team",
            "order": 10,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client"
            ],
            "wordCount": 412,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/kadena/client/api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/client\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Client Api",
            "label": "API Report File for \"@kadena/client\"",
            "order": 99,
            "editLink": null,
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "signing",
              "transaction",
              "typescript client",
              "reference"
            ],
            "wordCount": 1006,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/kadena/client",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Package @kadena/client",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "Client",
        "label": "Package @kadena/client",
        "order": 7,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client/README.md",
        "layout": "full",
        "tags": [
          "javascript",
          "typescript",
          "signing",
          "transaction",
          "typescript client"
        ],
        "wordCount": 460,
        "readingTimeInMinutes": 3,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/kadena/client-examples/transfer-kda",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Transfer KDA",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Transfer KDA",
            "label": "Transfer KDA",
            "order": 1,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client-examples/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "examples",
              "transfer"
            ],
            "wordCount": 1230,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/kadena/client-examples",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Preparation",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "Client examples",
        "label": "Preparation",
        "order": 8,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/client-examples/README.md",
        "layout": "full",
        "tags": [
          "javascript",
          "typescript",
          "examples",
          "transfer"
        ],
        "wordCount": 281,
        "readingTimeInMinutes": 2,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [],
        "root": "/docs/kadena/code-of-conduct",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Code of Conduct",
        "description": "Kadena Code of Conduct",
        "label": "Code of Conduct",
        "layout": "normal",
        "wordCount": 996,
        "readingTimeInMinutes": 5,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": false
      }
    ],
    "root": "/docs/kadena",
    "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
    "title": "Intro to Kadena",
    "menu": "Kadena",
    "subTitle": "Build the future on Kadena",
    "label": "Introduction",
    "order": 0,
    "description": "Welcome to Kadena&apos;s documentation!",
    "layout": "landing",
    "wordCount": 400,
    "readingTimeInMinutes": 2,
    "isMenuOpen": false,
    "isActive": false,
    "isIndex": true
  },
  {
    "children": [
      {
        "children": [
          {
            "children": [],
            "root": "/docs/build/quickstart/memorywall",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Sign the Memory Wall",
            "description": "Learn Kadena’s core concepts & tools for development in 15 minutes",
            "menu": "Sign the Memory Wall",
            "label": "Sign the Memory Wall",
            "order": 1,
            "layout": "full",
            "tags": [
              "chainweb",
              "chainweaver",
              "tutorial",
              "resources"
            ],
            "wordCount": 1022,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/quickstart/setup-chainweaver",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Setup Chainweaver",
            "description": "Learn Kadena’s core concepts & tools for development in 15 minutes",
            "menu": "Setup Chainweaver",
            "label": "Setup Chainweaver",
            "order": 2,
            "layout": "full",
            "tags": [
              "chainweaver",
              "tutorial",
              "resources"
            ],
            "wordCount": 123,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/quickstart/testnet-account-setup",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Testnet Account Setup",
            "description": "Learn Kadena’s core concepts & tools for development in 15 minutes",
            "menu": "Testnet Account Setup",
            "label": "Testnet Account Setup",
            "order": 3,
            "layout": "full",
            "tags": [
              "testnet",
              "account",
              "tutorial"
            ],
            "wordCount": 204,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/quickstart/pacty-parrots",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pacty Parrots",
            "description": "Learn Kadena’s core concepts & tools for development in 15 minutes",
            "menu": "Pacty Parrots",
            "label": "Pacty Parrots",
            "order": 4,
            "layout": "full",
            "tags": [
              "chainweb",
              "tutorial",
              "resources"
            ],
            "wordCount": 335,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/quickstart/dapp",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Build a Dapp",
            "description": "Apply your Kadena knowledge to build a brand new dApp. Created and funded an account. Performed multiple transactions, Interacted with Mainnet. Used Block Explorer and Chainweaver Used a gas station and signing API and Testnet. Used Block Explorer and Chainweaver",
            "menu": "Build a Dapp",
            "label": "Build a Dapp",
            "order": 7,
            "layout": "full",
            "tags": [
              "chainweb",
              "chainweaver",
              "tutorial",
              "resources"
            ],
            "wordCount": 249,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/build/quickstart",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "5 Minute Quickstart",
        "description": "Learn Kadena’s core concepts & tools for development in 5 minutes",
        "menu": "Quickstart",
        "label": "5 Minute Quickstart",
        "order": 1,
        "layout": "full",
        "tags": [
          "devnet",
          "chainweaver",
          "tutorial",
          "docker",
          "transactions"
        ],
        "wordCount": 499,
        "readingTimeInMinutes": 3,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/build/kda-cli/install",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Install",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Install",
            "label": "Install",
            "order": 1,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/kda-cli/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "kda",
              "chainweaver",
              "setup devnet",
              "cli",
              "client"
            ],
            "wordCount": 134,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/kda-cli/cli",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "CLI",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "CLI",
            "label": "CLI",
            "order": 2,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/kda-cli/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "kda",
              "chainweaver",
              "setup devnet",
              "cli",
              "client"
            ],
            "wordCount": 79,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/kda-cli/chainweaver",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Chainweaver",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Chainweaver",
            "label": "Chainweaver",
            "order": 3,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/kda-cli/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "kda",
              "chainweaver",
              "setup devnet",
              "cli",
              "client"
            ],
            "wordCount": 115,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/kda-cli/devnet",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Devnet",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Devnet",
            "label": "Devnet",
            "order": 4,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/kda-cli/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "kda",
              "chainweaver",
              "setup devnet",
              "cli",
              "client"
            ],
            "wordCount": 84,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/kda-cli/note",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "NOTE",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "NOTE",
            "label": "NOTE",
            "order": 5,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/kda-cli/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "kda",
              "chainweaver",
              "setup devnet",
              "cli",
              "client"
            ],
            "wordCount": 177,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/kda-cli/api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/kda-cli\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "KDA CLI Api",
            "label": "API Report File for \"@kadena/kda-cli\"",
            "order": 99,
            "editLink": null,
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "kda",
              "chainweaver",
              "setup devnet",
              "cli",
              "client",
              "reference"
            ],
            "wordCount": 82,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/build/kda-cli",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Prerequisite",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "KDA CLI",
        "label": "Prerequisite",
        "order": 3,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/kda-cli/README.md",
        "layout": "full",
        "tags": [
          "javascript",
          "typescript",
          "kda",
          "chainweaver",
          "setup devnet",
          "cli",
          "client"
        ],
        "wordCount": 146,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/build/cryptography-utils/api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/cryptography-utils\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Cryptography-Utils Api",
            "label": "API Report File for \"@kadena/cryptography-utils\"",
            "order": 98,
            "editLink": null,
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "cryptography examples",
              "functions"
            ],
            "wordCount": 279,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          },
          {
            "children": [],
            "root": "/docs/build/cryptography-utils/crypto-api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/cryptography-utils\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Crypto Api",
            "label": "API Report File for \"@kadena/cryptography-utils\"",
            "order": 99,
            "editLink": null,
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "cryptography examples",
              "functions",
              "reference"
            ],
            "wordCount": 252,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/build/cryptography-utils",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Cryptography Utils",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "Cryptography-Utils",
        "label": "Cryptography Utils",
        "order": 3,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/cryptography-utils/README.md",
        "layout": "full",
        "tags": [],
        "wordCount": 219,
        "readingTimeInMinutes": 2,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [
              {
                "children": [],
                "root": "/docs/build/cookbook/cookbook/setup",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Setup",
                "description": "Kadena makes blockchain work for everyone.",
                "menu": "Setup",
                "label": "Setup",
                "order": 1,
                "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/cookbook/README.md",
                "layout": "full",
                "tags": [
                  "javascript",
                  "typescript",
                  "pact",
                  "reference",
                  "api"
                ],
                "wordCount": 132,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/build/cookbook/cookbook/notes",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Notes",
                "description": "Kadena makes blockchain work for everyone.",
                "menu": "Notes",
                "label": "Notes",
                "order": 2,
                "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/cookbook/README.md",
                "layout": "full",
                "tags": [
                  "javascript",
                  "typescript",
                  "pact",
                  "reference",
                  "api"
                ],
                "wordCount": 245,
                "readingTimeInMinutes": 2,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              }
            ],
            "root": "/docs/build/cookbook/cookbook",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Overview",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "JS Cookbook",
            "label": "Overview",
            "order": 2,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/cookbook/README.md",
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "pact",
              "reference",
              "api"
            ],
            "wordCount": 125,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/build/cookbook",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Pact-lang-API Cookbook",
        "description": "Common use cases for `pact-lang-api`",
        "menu": "Cookbook",
        "label": "Cookbook",
        "order": 3,
        "layout": "full",
        "tags": [
          "pact",
          "typescript",
          "account",
          "transactions",
          "utils"
        ],
        "wordCount": 1280,
        "readingTimeInMinutes": 7,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/build/guides/marmalade-tutorial",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Marmalade Tutorial",
            "description": "Marmalade Tutorial",
            "menu": "Build",
            "label": "Marmalade Tutorial",
            "order": 1,
            "layout": "full",
            "tags": [
              "pact",
              "marmalade",
              "nft",
              "tutorial"
            ],
            "wordCount": 3205,
            "readingTimeInMinutes": 17,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/guides/pact-local-api-queries",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact Local API queries",
            "description": "Pact Local API queries",
            "menu": "Build",
            "label": "Pact Local API queries",
            "order": 2,
            "layout": "full",
            "tags": [
              "pact",
              "tutorial",
              "local api"
            ],
            "wordCount": 623,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/guides/building-a-voting-dapp",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Building a voting dApp",
            "description": "Building a voting dApp",
            "menu": "Build",
            "label": "Building a voting dApp",
            "order": 3,
            "layout": "full",
            "tags": [
              "pact",
              "smart contract",
              "typescript",
              "tutorial"
            ],
            "wordCount": 7354,
            "readingTimeInMinutes": 37,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/guides/safe-rotate-and-drain",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Safe Rotate and Drain",
            "description": "Safe Rotate and Drain",
            "menu": "Build",
            "label": "Safe Rotate and Drain",
            "order": 4,
            "layout": "full",
            "tags": [
              "pact",
              "tutorial",
              "signing"
            ],
            "wordCount": 219,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/build/guides/safe-transfer",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Safe Transfer",
            "description": "Safe Transfer",
            "menu": "Build",
            "label": "Safe Transfer",
            "order": 5,
            "layout": "full",
            "tags": [
              "pact",
              "tutorial",
              "transfer"
            ],
            "wordCount": 267,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/build/guides",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "A Step-By-Step Guide to Writing Pact Smart Contract",
        "description": "A Step-By-Step Guide to Writing Pact Smart Contract",
        "menu": "Build",
        "label": "Pact Smart Contract",
        "order": 4,
        "layout": "full",
        "tags": [
          "pact",
          "smart contract",
          "typescript",
          "tutorial"
        ],
        "wordCount": 6004,
        "readingTimeInMinutes": 31,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/build/resources/kuro-layer-2",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kuro layer 2 - guides",
            "description": "Kuro layer 2 - guides",
            "menu": "Resources",
            "label": "Pact Kuro layer 2",
            "order": 2,
            "layout": "full",
            "tags": [
              "kuro",
              "cluster",
              "resources"
            ],
            "wordCount": 192,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/build/resources",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Pact Resources",
        "description": "Resources to start building on Kadena with Pact.",
        "menu": "Resources",
        "label": "Pact Resources",
        "order": 6,
        "layout": "full",
        "tags": [
          "pact",
          "resources"
        ],
        "wordCount": 187,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      }
    ],
    "root": "/docs/build",
    "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
    "title": "Build on Kadena",
    "menu": "Build",
    "subTitle": "Build your best ideas with us",
    "label": "Introduction",
    "order": 1,
    "description": "Build on Kadena",
    "layout": "landing",
    "wordCount": 329,
    "readingTimeInMinutes": 2,
    "isMenuOpen": false,
    "isActive": false,
    "isIndex": true
  },
  {
    "children": [
      {
        "children": [],
        "root": "/docs/pact/overview",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Learn Pact",
        "description": "Kadena makes blockchain work for everyone.",
        "subTitle": "Welcome to the Pact Developer Tutorials",
        "menu": "Overview",
        "label": "Overview",
        "order": 1,
        "layout": "landing",
        "tags": [
          "pact",
          "pact definition",
          "prerequisites"
        ],
        "wordCount": 239,
        "readingTimeInMinutes": 2,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": false
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/pact/beginner/web-editor",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Web Editor",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Web Editor",
            "label": "Web Editor",
            "order": 2,
            "layout": "full",
            "tags": [
              "pact",
              "web editor",
              "pact tutorials"
            ],
            "wordCount": 2294,
            "readingTimeInMinutes": 12,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/hello-world",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Hello World",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Hello World",
            "label": "Hello World",
            "order": 2,
            "layout": "full",
            "tags": [
              "pact",
              "hello world",
              "tutorials",
              "hello world tutorial",
              "pact hello world",
              "smart contract deployment"
            ],
            "wordCount": 2123,
            "readingTimeInMinutes": 11,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/language-basics",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Language Basics",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Language Basics",
            "label": "Language Basics",
            "order": 4,
            "layout": "full",
            "tags": [
              "pact",
              "language basics"
            ],
            "wordCount": 3796,
            "readingTimeInMinutes": 19,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/modules",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Modules",
            "description": "This tutorial introduces an essential feature in Pact known as modules. We’ll discuss what modules are, why they’re important, and how they relate to smart contracts.",
            "menu": "Modules",
            "label": "Modules",
            "order": 5,
            "layout": "full",
            "tags": [
              "pact",
              "beginner",
              "modules",
              "pact modules tutorial"
            ],
            "wordCount": 1162,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/keysets",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Keysets",
            "description": "This tutorial introduces another essential feature in Pact known as keysets. We’ll discuss what keysets are, why they’re important, and how they help regulate access to Pact modules.",
            "menu": "Keysets",
            "label": "Keysets",
            "order": 6,
            "layout": "full",
            "tags": [
              "pact",
              "beginner",
              "keysets"
            ],
            "wordCount": 2977,
            "readingTimeInMinutes": 15,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/schemas-and-tables",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Schemas and Tables",
            "description": "The goal of this tutorial is to get you familiar with what schemas and tables are, why they’re useful, and to demonstrate how to implement these within a Pact smart contract.",
            "menu": "Schemas and Tables",
            "label": "Schemas and Tables",
            "order": 7,
            "layout": "full",
            "tags": [
              "pact",
              "beginner",
              "schemas and tables",
              "schemas",
              "tables",
              "pact tutorials"
            ],
            "wordCount": 2202,
            "readingTimeInMinutes": 12,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/atom-sdk",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Atom SDK",
            "description": "The goal of this tutorial is to get you up and running with the Pact environment and the Pact Atom SDK to begin running Pact programs locally.",
            "menu": "Atom SDK",
            "label": "Atom SDK",
            "order": 8,
            "layout": "full",
            "tags": [
              "pact",
              "atom sdk",
              "pact installation",
              "local development"
            ],
            "wordCount": 1244,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/accounts-and-transfers",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Accounts and Transfers",
            "description": "The goal of this tutorial is to help you build an application that transfers value between two accounts. To do this, you’ll build a smart contract that implements this functionality named Simple Payments. This is an important function of smart contracts and will set you up to create more complex applications using accounts and transfers.",
            "menu": "Accounts and Transfers",
            "label": "Accounts and Transfers",
            "order": 9,
            "layout": "full",
            "tags": [
              "pact",
              "beginner tutorials",
              "accounts and transfers"
            ],
            "wordCount": 1611,
            "readingTimeInMinutes": 9,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/contract-interaction",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Contract Interaction",
            "description": "The goal of this tutorial is to learn the basics of building interactions between modules in Pact. You will go over some of the fundamentals, then build a smart contract that allows users to both make and authorize payments using multiple Pact modules.",
            "menu": "Contract Interaction",
            "label": "Contract Interaction",
            "order": 10,
            "layout": "full",
            "tags": [
              "pact",
              "contract interaction"
            ],
            "wordCount": 2443,
            "readingTimeInMinutes": 13,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/rotatable-wallet",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Rotatable Wallet",
            "description": "Here you’ll create a smart contract named Rotatable Wallets that demonstrates many important Pact features that you learned throughout previous tutorials.",
            "menu": "Rotatable Wallet",
            "label": "Rotatable Wallet",
            "order": 11,
            "layout": "full",
            "tags": [
              "pact",
              "beginner",
              "rotatable wallet",
              "rotatable wallet tutorial",
              "tutorial"
            ],
            "wordCount": 2154,
            "readingTimeInMinutes": 11,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/loans",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Loans",
            "description": "In this tutorial, you will build an example loans application using many of the techniques you learned in earlier tutorials",
            "menu": "Loans",
            "label": "Loans",
            "order": 12,
            "layout": "full",
            "tags": [
              "pact",
              "beginner",
              "loans"
            ],
            "wordCount": 2891,
            "readingTimeInMinutes": 15,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/beginner/test-in-the-sdk",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Test in the SDK",
            "description": "In this tutorial, you will learn the basics of testing in the SDK to build your own REPL file. This is a great start to begin testing the smart contracts you build locally.",
            "menu": "Test in the SDK",
            "label": "Test in the SDK",
            "order": 13,
            "layout": "full",
            "tags": [
              "pact",
              "sdk",
              "repl",
              "repl file",
              "pact repl"
            ],
            "wordCount": 3095,
            "readingTimeInMinutes": 16,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/pact/beginner",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Welcome to Pact",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "Beginner",
        "label": "Welcome to Pact",
        "order": 2,
        "layout": "full",
        "tags": [
          "pact",
          "pact tutorial",
          "pact beginner",
          "pact introduction"
        ],
        "wordCount": 1466,
        "readingTimeInMinutes": 8,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/pact/intermediate/pact-and-javascript",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact and JavaScript",
            "description": "The goal of this tutorial is to help you connect your Pact development environment to a front end application.",
            "menu": "Pact and JavaScript",
            "label": "Pact and JavaScript",
            "order": 2,
            "layout": "full",
            "tags": [
              "pact",
              "tutorials",
              "intermediate",
              "pact javascript"
            ],
            "wordCount": 3055,
            "readingTimeInMinutes": 16,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/intermediate/safety-using-control-flow",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Safety Using Control Flow",
            "description": "In this tutorial, we’ll focus specifically on how Pact approaches control flow to ensure safety.",
            "menu": "Safety Using Control Flow",
            "label": "Safety",
            "order": 3,
            "layout": "full",
            "tags": [
              "pact",
              "intermediate",
              "safety",
              "control flow"
            ],
            "wordCount": 2896,
            "readingTimeInMinutes": 15,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/intermediate/interfaces-with-pact",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Interfaces with Pact",
            "description": "Throughout this tutorial you’ll learn why interfaces are valuable and how to implement them with Pact.",
            "menu": "Interfaces with Pact",
            "label": "Interfaces with Pact",
            "order": 4,
            "layout": "full",
            "tags": [
              "pact",
              "tutorials",
              "interfaces"
            ],
            "wordCount": 2096,
            "readingTimeInMinutes": 11,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/intermediate/built-in-functions",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Built in Functions",
            "description": "In this guide, we will go through and explain specific built-in functions that are listed in the pact reference page",
            "menu": "Built in Functions",
            "label": "Built in Functions",
            "order": 5,
            "layout": "full",
            "tags": [
              "pact",
              "built in functions",
              "intermediate",
              "pact tutorials"
            ],
            "wordCount": 1106,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/pact/intermediate",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Deploy to a Local Server",
        "description": "The goal of this tutorial is to help you run and deploy a working Pact test server locally.",
        "menu": "Intermediate",
        "label": "Intermediate",
        "order": 3,
        "layout": "full",
        "tags": [
          "pact",
          "intermediate",
          "deploy to local server",
          "local test server tutorial"
        ],
        "wordCount": 2713,
        "readingTimeInMinutes": 14,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/pact/reference/rest-api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact Rest API",
            "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
            "menu": "Pact Rest API",
            "label": "Pact Rest API",
            "order": 2,
            "layout": "full",
            "tags": [
              "pact",
              "rest api",
              "pact api",
              "pact api reference"
            ],
            "wordCount": 1411,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/reference/concepts",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Concepts",
            "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
            "menu": "Concepts",
            "label": "Concepts",
            "order": 3,
            "layout": "full",
            "tags": [
              "pact",
              "concepts",
              "declaration"
            ],
            "wordCount": 9423,
            "readingTimeInMinutes": 48,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/reference/syntax",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Syntax",
            "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
            "menu": "Syntax",
            "label": "Syntax",
            "order": 4,
            "layout": "full",
            "tags": [
              "pact",
              "language reference",
              "syntax"
            ],
            "wordCount": 2619,
            "readingTimeInMinutes": 14,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/reference/time-formats",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Time Formats",
            "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
            "menu": "Time Formats",
            "label": "Time Formats",
            "order": 5,
            "layout": "full",
            "tags": [
              "pact",
              "language reference",
              "time formats"
            ],
            "wordCount": 786,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [
              {
                "children": [],
                "root": "/docs/pact/reference/functions/database",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Database",
                "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
                "menu": "Database",
                "label": "Database",
                "order": 2,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "database"
                ],
                "wordCount": 747,
                "readingTimeInMinutes": 4,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/functions/time",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Time",
                "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
                "menu": "Time",
                "label": "Time",
                "order": 3,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "time"
                ],
                "wordCount": 372,
                "readingTimeInMinutes": 2,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/functions/operators",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Operators",
                "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
                "menu": "Operators",
                "label": "Operators",
                "order": 4,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "operators"
                ],
                "wordCount": 1295,
                "readingTimeInMinutes": 7,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/functions/keysets",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Keysets",
                "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
                "menu": "Keysets",
                "label": "Keysets",
                "order": 5,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "keysets"
                ],
                "wordCount": 277,
                "readingTimeInMinutes": 2,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/functions/capabilities",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Capabilities",
                "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
                "menu": "Capabilities",
                "label": "Capabilities",
                "order": 6,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "capabilities"
                ],
                "wordCount": 582,
                "readingTimeInMinutes": 3,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/functions/spv",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "SPV",
                "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
                "menu": "SPV",
                "label": "SPV",
                "order": 7,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "spv",
                  "spv proof verification"
                ],
                "wordCount": 104,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/functions/commitments",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Commitments",
                "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
                "menu": "Commitments",
                "label": "Commitments",
                "order": 8,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "commitments"
                ],
                "wordCount": 183,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/functions/guards",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Guards",
                "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
                "menu": "Guards",
                "label": "Guards",
                "order": 9,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "guards"
                ],
                "wordCount": 417,
                "readingTimeInMinutes": 3,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/functions/zk",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "ZK",
                "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
                "menu": "ZK",
                "label": "ZK",
                "order": 10,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "zk",
                  "zk proof verification"
                ],
                "wordCount": 168,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/functions/repl-only-functions",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "REPL-only functions",
                "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
                "menu": "REPL-only functions",
                "label": "REPL-only functions",
                "order": 11,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "repl-only functions",
                  "repl functions"
                ],
                "wordCount": 1653,
                "readingTimeInMinutes": 9,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              }
            ],
            "root": "/docs/pact/reference/functions",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Built-in Functions",
            "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
            "menu": "Built-in Functions",
            "label": "General",
            "order": 6,
            "layout": "full",
            "tags": [
              "pact",
              "language reference",
              "built-in functions"
            ],
            "wordCount": 2768,
            "readingTimeInMinutes": 14,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          },
          {
            "children": [],
            "root": "/docs/pact/reference/property-checking",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact Property Checking System",
            "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
            "menu": "Pact Property Checking System",
            "label": "Pact Property Checking System",
            "order": 7,
            "layout": "full",
            "tags": [
              "pact",
              "property checking system"
            ],
            "wordCount": 2757,
            "readingTimeInMinutes": 14,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/numerical",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Numerical Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Numerical Operators",
                "label": "Numerical operators",
                "order": 2,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "numerical operators",
                  "pact operators"
                ],
                "wordCount": 548,
                "readingTimeInMinutes": 3,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/bitwise",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Bitwise Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Bitwise Operators",
                "label": "Bitwise Operators",
                "order": 3,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "bitwise operators",
                  "pact operators"
                ],
                "wordCount": 157,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/logical",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Logical Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Logical Operators",
                "label": "Logical Operators",
                "order": 4,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "logical operators",
                  "pact operators"
                ],
                "wordCount": 411,
                "readingTimeInMinutes": 3,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/object",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Object Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Object Operators",
                "label": "Object Operators",
                "order": 5,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "object operators",
                  "pact operators"
                ],
                "wordCount": 176,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/list",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "List Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "List Operators",
                "label": "Object Operators",
                "order": 6,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "list operators",
                  "object operators",
                  "pact operators"
                ],
                "wordCount": 463,
                "readingTimeInMinutes": 3,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/string",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "String Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "String Operators",
                "label": "String Operators",
                "order": 7,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "string operators",
                  "pact operators"
                ],
                "wordCount": 246,
                "readingTimeInMinutes": 2,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/temporal",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Temporal Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Temporal Operators",
                "label": "Temporal Operators",
                "order": 8,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "temporal operators",
                  "pact operators"
                ],
                "wordCount": 79,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/quantification",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Quantification Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Quantification Operators",
                "label": "Quantification Operators",
                "order": 9,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "quantification operators",
                  "pact operators"
                ],
                "wordCount": 152,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/transactional",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Transactional Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Transactional Operators",
                "label": "Transactional Operators",
                "order": 10,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "transactional operators",
                  "pact operators"
                ],
                "wordCount": 280,
                "readingTimeInMinutes": 2,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/database",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Database Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Database Operators",
                "label": "Database Operators",
                "order": 11,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "database operators",
                  "pact operators"
                ],
                "wordCount": 553,
                "readingTimeInMinutes": 3,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/authorization",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Authorization Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Authorization Operators",
                "label": "Authorization Operators",
                "order": 12,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "authorization operators",
                  "pact authorization"
                ],
                "wordCount": 190,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/function",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Function Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Function Operators",
                "label": "Function Operators",
                "order": 13,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "function operators",
                  "pact operators"
                ],
                "wordCount": 123,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              },
              {
                "children": [],
                "root": "/docs/pact/reference/properties-and-invariants/other",
                "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
                "title": "Other Operators",
                "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
                "menu": "Other Operators",
                "label": "Other Operators",
                "order": 14,
                "layout": "full",
                "tags": [
                  "pact",
                  "language reference",
                  "other operators",
                  "pact operators"
                ],
                "wordCount": 105,
                "readingTimeInMinutes": 1,
                "isMenuOpen": false,
                "isActive": false,
                "isIndex": false
              }
            ],
            "root": "/docs/pact/reference/properties-and-invariants",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Property and Invariant Functions",
            "description": "Pact comes equipped with the ability for smart contract authors to express and automatically check properties -- or, specifications -- of Pact programs.",
            "menu": "Property and Invariant Functions",
            "label": "Intro",
            "order": 8,
            "layout": "full",
            "tags": [
              "pact",
              "language reference",
              "property and invariant functions",
              "pact functions"
            ],
            "wordCount": 127,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/pact/reference",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Language Reference",
        "description": "This document is a reference for the Pact smart-contract language, designed for correct, transactional execution on a high-performance blockchain.",
        "menu": "Language Reference",
        "label": "Intro",
        "order": 4,
        "layout": "full",
        "tags": [
          "pact",
          "language reference"
        ],
        "wordCount": 92,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [],
        "root": "/docs/pact/api",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Pact OpenAPI",
        "menu": "Docs",
        "subTitle": "Be a part of our ecosystem",
        "label": "Pact OpenAPI",
        "order": 5,
        "description": "Be a part of our ecosystem",
        "layout": "redocly",
        "wordCount": 125,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/pact/pactjs/api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/pactjs\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "PactJS Api",
            "label": "API Report File for \"@kadena/pactjs\"",
            "order": 98,
            "editLink": null,
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "pact",
              "reference"
            ],
            "wordCount": 140,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          },
          {
            "children": [],
            "root": "/docs/pact/pactjs/utils",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/pactjs\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "PactJS Utils",
            "label": "API Report File for \"@kadena/pactjs\"",
            "order": 99,
            "editLink": null,
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "pact",
              "reference"
            ],
            "wordCount": 128,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/pact/pactjs",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "PactJS",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "PactJS",
        "label": "PactJS",
        "order": 6,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/pactjs/README.md",
        "layout": "full",
        "tags": [
          "javascript",
          "typescript",
          "pact"
        ],
        "wordCount": 91,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/pact/cli/retrievecontract",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "retrieve-contract",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "retrieve-contract",
            "label": "retrieve-contract",
            "order": 1,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/pactjs-cli/README.md",
            "layout": "full",
            "tags": [
              "pactjs",
              "cli",
              "client",
              "contracts"
            ],
            "wordCount": 170,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/cli/templategenerate",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "template-generate",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "template-generate",
            "label": "template-generate",
            "order": 2,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/pactjs-cli/README.md",
            "layout": "full",
            "tags": [
              "pactjs",
              "cli",
              "client",
              "contracts"
            ],
            "wordCount": 124,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/pact/cli/api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/pactjs-cli\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "CLI tool Api",
            "label": "API Report File for \"@kadena/pactjs-cli\"",
            "order": 99,
            "editLink": null,
            "layout": "full",
            "tags": [
              "pactjs",
              "cli",
              "client",
              "contracts",
              "reference"
            ],
            "wordCount": 78,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/pact/cli",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "generate",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "CLI tool",
        "label": "generate",
        "order": 6,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/tools/pactjs-cli/README.md",
        "layout": "full",
        "tags": [
          "pactjs",
          "cli",
          "client",
          "contracts"
        ],
        "wordCount": 223,
        "readingTimeInMinutes": 2,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/pact/pactjs-generator/api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/pactjs-generator\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "PactJS Generator Api",
            "label": "API Report File for \"@kadena/pactjs-generator\"",
            "order": 99,
            "editLink": null,
            "layout": "full",
            "tags": [
              "javascript",
              "typescript",
              "pact",
              "reference",
              "api"
            ],
            "wordCount": 205,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/pact/pactjs-generator",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "PactJS Generator",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "PactJS Generator",
        "label": "PactJS Generator",
        "order": 7,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/pactjs-generator/README.md",
        "layout": "full",
        "tags": [
          "javascript",
          "typescript",
          "pact",
          "reference",
          "api"
        ],
        "wordCount": 100,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [],
        "root": "/docs/pact/vscode",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Visual Studio Code configuration for Pact",
        "description": "This document describes how to configure Visual Studio code for Pact development using the Pact extension.",
        "menu": "Visual Studio Code",
        "label": "Visual Studio Code",
        "order": 9,
        "layout": "full",
        "tags": [
          "pact",
          "IDE integration",
          "Visual Studio Code configuration",
          "Visual Studio Code extension",
          "Visual Studio Code pact extension"
        ],
        "wordCount": 448,
        "readingTimeInMinutes": 3,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [],
        "root": "/docs/pact/pactjs-test-project",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "PactJS Test Project",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "Test Project",
        "label": "PactJS Test Project",
        "order": 10,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/pactjs-test-project/README.md",
        "layout": "full",
        "tags": [
          "pact",
          "pactjs",
          "pactjs test project",
          "pactjs tutorial",
          "pactjs example"
        ],
        "wordCount": 132,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      }
    ],
    "root": "/docs/pact",
    "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
    "title": "Learn Pact",
    "subTitle": "The human-readable smart contract language",
    "menu": "Pact",
    "label": "Pact",
    "order": 3,
    "description": "The human-readable smart contract language",
    "layout": "landing",
    "wordCount": 549,
    "readingTimeInMinutes": 3,
    "isMenuOpen": false,
    "isActive": false,
    "isIndex": true
  },
  {
    "children": [
      {
        "children": [
          {
            "children": [],
            "root": "/docs/contribute/node/start-mining",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Start Mining",
            "description": "Resources",
            "menu": "Start Mining",
            "label": "Start Mining",
            "order": 2,
            "layout": "full",
            "wordCount": 258,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/contribute/node/interact-with-nodes",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Interact with Nodes",
            "description": "Resources",
            "menu": "Interact with Nodes",
            "label": "Interact with Nodes",
            "order": 3,
            "layout": "full",
            "wordCount": 54,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/contribute/node/troubleshooting-chainweb",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Troubleshooting Chainweb",
            "description": "If you're running a node and getting something like this the following, then it means that peer synchronization has failed",
            "menu": "Troubleshooting Chainweb",
            "label": "Troubleshooting Chainweb",
            "order": 4,
            "layout": "full",
            "wordCount": 836,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/contribute/node",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Run a node",
        "description": "Resources",
        "menu": "Run a node",
        "label": "Introduction",
        "order": 2,
        "layout": "full",
        "wordCount": 214,
        "readingTimeInMinutes": 2,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/contribute/ambassadors/content-creator",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Content Creator",
            "description": "Content Creators amplify Kadena’s brand by educating the wider community about Kadena through informative collateral whether visual or audio.",
            "menu": "Content Creator",
            "label": "Content Creator",
            "order": 2,
            "layout": "full",
            "wordCount": 718,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/contribute/ambassadors/moderator",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Moderator",
            "description": "Moderators are essential to keeping our official online social media channels up to date as well as providing a welcoming environment for community members to come together and monitoring those discussions.",
            "menu": "Moderator",
            "label": "Moderator",
            "order": 3,
            "layout": "full",
            "wordCount": 201,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/contribute/ambassadors/community-channel-leader",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Communnity Channel Leader",
            "description": "Community channels serve as a home for community members to discuss niche topics about Kadena or share news about Kadena not otherwise discussed in the main channel. To foster community growth on a more organic level, Kadena plans to help fund community channels by token awards to Community Channel Leaders who create the group and the community events.",
            "menu": "Communnity Channel Leader",
            "label": "Communnity Channel Leader",
            "order": 4,
            "layout": "full",
            "wordCount": 277,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/contribute/ambassadors",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Ambassador Overview",
        "description": "Join a community of passionate individuals in helping spread Kadena's brand and mission",
        "menu": "Ambassadors",
        "label": "Ambassadors",
        "order": 3,
        "layout": "full",
        "wordCount": 786,
        "readingTimeInMinutes": 4,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [],
        "root": "/docs/contribute/kadena-dao",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Kadena DAO",
        "description": "Meaningful Initiatives Driven by the Voice of the Community",
        "menu": "Kadena DAO",
        "label": "Kadena DAO",
        "order": 4,
        "layout": "full",
        "wordCount": 743,
        "readingTimeInMinutes": 4,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": false
      },
      {
        "children": [],
        "root": "/docs/contribute/contribute",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Contribute to Kadena Docs",
        "description": "How to contribute to the docs from docs.kadena.io, GitHub, or a local environment.",
        "menu": "Docs",
        "label": "Docs",
        "order": 5,
        "layout": "full",
        "wordCount": 983,
        "readingTimeInMinutes": 5,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": false
      }
    ],
    "root": "/docs/contribute",
    "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
    "title": "Contribute",
    "menu": "Contribute",
    "subTitle": "Be a part of our ecosystem",
    "label": "Contribute",
    "order": 4,
    "description": "Be a part of our ecosystem",
    "layout": "landing",
    "wordCount": 372,
    "readingTimeInMinutes": 2,
    "isMenuOpen": false,
    "isActive": false,
    "isIndex": true
  },
  {
    "children": [
      {
        "children": [
          {
            "children": [],
            "root": "/docs/chainweb/node-client/pact",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Pact",
            "label": "Pact",
            "order": 1,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/chainweb-node-client/README.md",
            "layout": "full",
            "tags": [
              "chainweb",
              "pact",
              "reference"
            ],
            "wordCount": 336,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/chainweb/node-client/api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/chainweb-node-client\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Client Api",
            "label": "API Report File for \"@kadena/chainweb-node-client\"",
            "order": 99,
            "editLink": null,
            "layout": "full",
            "tags": [
              "chainweb",
              "api",
              "reference"
            ],
            "wordCount": 568,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/chainweb/node-client",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Chainweb Node Client",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "Node Client",
        "label": "Chainweb Node Client",
        "order": 1,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/chainweb-node-client/README.md",
        "layout": "full",
        "tags": [
          "chainweb",
          "pact",
          "reference"
        ],
        "wordCount": 137,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/chainweb/stream-client/installation",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Installation",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Installation",
            "label": "Installation",
            "order": 1,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/chainweb-stream-client/README.md",
            "layout": "full",
            "tags": [
              "chainweb",
              "stream",
              "reference"
            ],
            "wordCount": 66,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/chainweb/stream-client/usage",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Usage",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Usage",
            "label": "Usage",
            "order": 2,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/chainweb-stream-client/README.md",
            "layout": "full",
            "tags": [
              "chainweb",
              "stream",
              "reference"
            ],
            "wordCount": 87,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/chainweb/stream-client/constructor-options",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Constructor Options",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Constructor Options",
            "label": "Constructor Options",
            "order": 3,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/chainweb-stream-client/README.md",
            "layout": "full",
            "tags": [
              "chainweb",
              "stream",
              "reference"
            ],
            "wordCount": 140,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/chainweb/stream-client/considerations",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Considerations ⚠️",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Considerations ⚠️",
            "label": "Considerations ⚠️",
            "order": 4,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/chainweb-stream-client/README.md",
            "layout": "full",
            "tags": [
              "chainweb",
              "stream",
              "reference"
            ],
            "wordCount": 189,
            "readingTimeInMinutes": 1,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/chainweb/stream-client/events",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Events",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Events",
            "label": "Events",
            "order": 5,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/chainweb-stream-client/README.md",
            "layout": "full",
            "tags": [
              "chainweb",
              "stream",
              "reference"
            ],
            "wordCount": 425,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/chainweb/stream-client/api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/chainweb-stream-client\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Stream Api",
            "label": "API Report File for \"@kadena/chainweb-stream-client\"",
            "order": 99,
            "editLink": null,
            "layout": "full",
            "tags": [
              "chainweb",
              "stream",
              "reference"
            ],
            "wordCount": 360,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/chainweb/stream-client",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "Status",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "Stream Client",
        "label": "Status",
        "order": 2,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/chainweb-stream-client/README.md",
        "layout": "full",
        "tags": [
          "chainweb",
          "stream",
          "reference"
        ],
        "wordCount": 52,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/chainweb/js-bindings/example-values",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Example Values",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "Example Values",
            "label": "Example Values",
            "order": 1,
            "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/chainwebjs/README.md",
            "layout": "full",
            "tags": [
              "chainweb",
              "javascript",
              "typescript",
              "stream"
            ],
            "wordCount": 219,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/chainweb/js-bindings/api",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "API Report File for \"@kadena/chainwebjs\"",
            "description": "Kadena makes blockchain work for everyone.",
            "menu": "JS bindings API",
            "label": "API Report File for \"@kadena/chainwebjs\"",
            "order": 99,
            "editLink": null,
            "layout": "full",
            "tags": [
              "chainweb",
              "javascript",
              "typescript",
              "stream",
              "reference"
            ],
            "wordCount": 395,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": true
          }
        ],
        "root": "/docs/chainweb/js-bindings",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "API Documentation",
        "description": "Kadena makes blockchain work for everyone.",
        "menu": "JS bindings",
        "label": "API Documentation",
        "order": 3,
        "editLink": "https://github.com/kadena-community/kadena.js/edit/main/packages/libs/chainwebjs/README.md",
        "layout": "full",
        "tags": [
          "chainweb",
          "javascript",
          "typescript",
          "stream"
        ],
        "wordCount": 896,
        "readingTimeInMinutes": 5,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      }
    ],
    "root": "/docs/chainweb",
    "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
    "title": "Intro to Chainweb",
    "menu": "Chainweb",
    "subTitle": "Build the future on Kadena",
    "label": "Introduction",
    "order": 5,
    "description": "Welcome to Chainwebs documentation!",
    "layout": "redocly",
    "wordCount": 103,
    "readingTimeInMinutes": 1,
    "isMenuOpen": false,
    "isActive": false,
    "isIndex": true
  },
  {
    "children": [],
    "root": "/docs/marmalade",
    "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
    "title": "Overview - Marmalade v1",
    "description": "A Brief history of marmalade",
    "menu": "Marmalade",
    "label": "Overview",
    "order": 6,
    "layout": "landing",
    "wordCount": 498,
    "readingTimeInMinutes": 3,
    "isMenuOpen": false,
    "isActive": false,
    "isIndex": true
  },
  {
    "children": [
      {
        "children": [
          {
            "children": [],
            "root": "/docs/blogchain/2023/an-introductory-guide-to-kadena-namespaces-2023-01-11",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "An Introductory Guide to Kadena Namespaces",
            "description": "When interacting with smart contracts on Chainweb, one will often see module names or module member expressions prefixed with static names such as free, or util, or kaddex (e.g. free.radio02.direct-to-send). We refer to these static prefixes as “namespaces”, and they form an integral part of the Kadena ecosystem that allows developers and users to write contract and keyset definitions within a private namespace that they govern themselves.",
            "menu": "Intro to Kadena Namespaces",
            "label": "Intro to Kadena Namespaces",
            "publishDate": "2023-01-11T00:00:00.000Z",
            "headerImage": "/assets/blog/0_FfPIMjWvXsk0NFOP.webp",
            "tags": [
              "kadena",
              "pact",
              "chainweb"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 1386,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/bringing-the-internet-to-the-physical-world-with-iot-devices-2023-06-08",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Bringing the Internet to the Physical World with IoT Devices",
            "description": "The Internet of Things (IoT) has become a buzzword in the technology industry in recent years. It refers to the interconnected network of devices, sensors, and systems that are able to communicate with each other, collect and share data, and perform automated actions without human intervention. This technology has the potential to revolutionize many industries, from healthcare to transportation, and has already started to transform our daily lives in numerous ways.",
            "menu": "IoT Devices",
            "label": "IoT Devices",
            "publishDate": "2023-06-08T00:00:00.000Z",
            "headerImage": "/assets/blog/1_-sZboC_fQJg1hXLc1uPAgQ.webp",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1207,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/chainweaver-2-2-3-improving-user-experience-with-quicksign-support-2023-02-10",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Chainweaver 2.2.3 - Improving User Experience with Quicksign Support",
            "description": "In our latest Chainweaver wallet version 2.2.3, we’re excited to highlight an amazing new addition that will take the user experience to the next level quicksign support for desktop applications! Based on KIP-0015, the quicksign API allows wallets to sign multiple transactions in a single request.",
            "menu": "Chainweaver 2.2.3",
            "label": "Chainweaver 2.2.3",
            "publishDate": "2023-02-10T00:00:00.000Z",
            "headerImage": "/assets/blog/1_eQ0aqLVMW21bLxOF1PB8yQ.webp",
            "tags": [
              "chainweaver"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 572,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/clarification-to-the-2021-token-economics-update-2023-08-22",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Clarification to the 2021 Token Economics Update",
            "description": "At Kadena, we’re proud of our token economic model, as it provides robust rewards for the miners who keep our network running, and funds all the critical initiatives that drive adoption on the platform. In January 2021, working closely with our incredible community, Kadena announced a major update to our token economic model in January 2021.",
            "menu": "Clarification to the 2021 Token Economics Update",
            "label": "Clarification to the 2021 Token Economics Update",
            "publishDate": "2023-08-22T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_68w6sDAETJxMRc_R4wjKmw.webp",
            "tags": [
              "token",
              "kda"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 671,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/decentralized-oracles-how-kadena-is-redefining-data-reliability-2023-04-25",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Decentralized Oracles How Kadena is Redefining Data Reliability",
            "description": "Decentralized Finance (DeFi) has taken the blockchain world by storm, offering new ways for individuals to access financial services without the need for traditional financial institutions. However, for DeFi to truly succeed, it must be able to interact with the real-world data that is necessary for financial applications to function properly. This is where Oracles come in.",
            "menu": "Decentralized Oracles",
            "label": "Decentralized Oracles",
            "publishDate": "2023-04-25T00:00:00.000Z",
            "headerImage": "/assets/blog/1_xwHa6WkMdrc7q43KhHDdJQ.webp",
            "tags": [
              "oracle",
              "kadena",
              "defi"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 940,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/forecasting-the-2023-kadena-js-experience-2023-01-13",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Curating the Kadena.js Dev Experience - 2022–2023",
            "description": "I knew I had a tough challenge ahead when I joined the Kadena team in April 2022 with the goal of creating a unique Dev Experience team. I was new to crypto and had to learn the ins-and- outs of a wildly complicated industry. I also knew I could bring great value because of my extensive engineering background and passion for front-end development.",
            "menu": "Curating the Kadena.js Dev Experience - 2022–2023",
            "label": "Curating the Kadena.js Dev Experience - 2022–2023",
            "publishDate": "2023-01-13T00:00:00.000Z",
            "headerImage": "/assets/blog/1_gg9ye2dLsWtNjIbG_DfFlA.webp",
            "tags": [
              "kadenajs"
            ],
            "author": "Randy Daal",
            "authorId": "randy.daal",
            "layout": "blog",
            "wordCount": 768,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/guide-to-building-a-lending-protocol-on-kadena-charkha-2023-03-21",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Guide to Building a Lending Protocol on Kadena — Charkha",
            "description": "Decentralized finance (DeFi) emerged as a standout application of blockchain technology in late 2017 and broke into the mainstream in 2020. Decentralized finance represents a vision of a financial system that operates without intermediaries such as banks and other third-party entities. It instead relies on the power of smart contracts to facilitate transactions.",
            "menu": "Guide to Building a Lending Protocol on Kadena — Charkha",
            "label": "Guide to Building a Lending Protocol on Kadena — Charkha",
            "publishDate": "2023-03-21T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1671,
            "readingTimeInMinutes": 9,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/harnessing-formal-verification-for-smart-contract-specification-2023-07-05",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Harnessing Formal Verification for Smart Contract Specification",
            "description": "Kadena’s smart contract language, Pact, is a powerful tool at our disposal. Pact assists developers in creating smart contracts on the Kadena blockchain, called Formal Verification. So what is Formal Verification? In the context of hardware and software systems, formal verification is the act of proving or disproving the correctness of intended algorithms underlying a system with respect to a certain formal specification or property, using formal methods of mathematics.",
            "menu": "Harnessing Formal Verification for Smart Contract Specification",
            "label": "Harnessing Formal Verification for Smart Contract Specification",
            "publishDate": "2023-07-05T00:00:00.000Z",
            "headerImage": "/assets/blog/1_I5E__mD5RA-gfneIBQgKag.webp",
            "tags": [
              "smart contract",
              "formal verification",
              "pact"
            ],
            "author": "Andy",
            "authorId": "andy",
            "layout": "blog",
            "wordCount": 2709,
            "readingTimeInMinutes": 14,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/introducing-chainweb-stream-poll-less-do-more-2023-07-19",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Introducing Chainweb-stream - poll less, do more",
            "description": "We are delighted to present the first experimental versions of the chainweb-stream server and client, a new system that enables persistent streaming of transactions and their confirmation status.",
            "menu": "Introducing Chainweb-stream - poll less, do more",
            "label": "Introducing Chainweb-stream - poll less, do more",
            "publishDate": "2023-07-19T00:00:00.000Z",
            "headerImage": "/assets/blog/1_ITDZBMILfIYTkDa-djT-8g.webp",
            "tags": [
              "chainweb"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1021,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/introducing-marmalade-v2-empowering-the-future-of-nfts-2023-06-16",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Introducing Marmalade V2 - Empowering the Future of NFTs",
            "description": "The long-awaited release of Marmalade’s V2 standard has arrived, bringing a host of exciting updates and features to the top NFT standard in the industry! If you’ve been tracking the progress of Kadena and its NFT standards, you know we’ve been on a journey from the unstandardised on-chain metadata and single-policy token logic in V1 (KIP-13) to a far more robust and dynamic V2 (KIP-20). We’re thrilled to share the next stage of this adventure.",
            "menu": "Introducing Marmalade V2 - Empowering the Future of NFTs",
            "label": "Introducing Marmalade V2 - Empowering the Future of NFTs",
            "publishDate": "2023-06-16T00:00:00.000Z",
            "headerImage": "/assets/blog/1_zGdTSmjV4Q0BQWJ6ulpMIA.webp",
            "tags": [
              "marmalade"
            ],
            "author": "Heekyun",
            "authorId": "heekyun",
            "layout": "blog",
            "wordCount": 921,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/kadena-2023-q1-newsletter-2023-04-05",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena 2023 Q1 Newsletter",
            "description": "Decentralized finance (DeFi) emerged as a standout application of blockchain technology in late 2017 and broke into the mainstream in 2020. Decentralized finance represents a vision of a financial system that operates without intermediaries such as banks and other third-party entities. It instead relies on the power of smart contracts to facilitate transactions.",
            "menu": "Kadena 2023 Q1 Newsletter",
            "label": "Kadena 2023 Q1 Newsletter",
            "publishDate": "2023-04-05T00:00:00.000Z",
            "headerImage": "/assets/blog/1_vA09z1Z28bu459OOK2H5iA.webp",
            "tags": [
              "kadena",
              "grantee"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1450,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/kadena-2023-q2-newsletter-2023-07-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena 2023 Q2 Newsletter",
            "description": "As we delve into the exciting developments and achievements of the past three months in our Kadena Q2 Newsletter, we are thrilled to share the latest updates and developments in our ecosystem. Over the past quarter, Kadena has continued to push boundaries, foster innovation, and empower our community of builders and developers with cutting-edge technology. From groundbreaking partnerships to the launch of new projects and the expansion of our global community, there is much to celebrate!",
            "menu": "Kadena 2023 Q2 Newsletter",
            "label": "Kadena Kadena 2023 Q2 Newsletter",
            "publishDate": "2023-07-06T00:00:00.000Z",
            "headerImage": "/assets/blog/1_CfQ03AfVSFcTBFdaPAYdQw.webp",
            "tags": [
              "kadena",
              "pact",
              "bridge",
              "smart wallet"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1847,
            "readingTimeInMinutes": 10,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/kadena-grant-recipient-massive-to-launch-nopool-a-decentralized-carbon-neutral-proof-of-work-2023-02-21",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Grant Recipient Massive to Launch NoPool, a Decentralized Carbon Neutral Proof-of-Work Mining Pool",
            "description": "NoPool will provide incentives for proof-of-work miners to work towards carbon neutral emissions goals with support from BITMAIN in the form of computing power",
            "menu": "Kadena Grant Recipient Massive to Launch NoPool",
            "label": "Kadena Grant Recipient Massive to Launch NoPool",
            "publishDate": "2023-02-21T00:00:00.000Z",
            "headerImage": "/assets/blog/1_dON9Q1uWxLdnxbVglCoGQw.webp",
            "tags": [
              "nopool",
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1028,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/kadena-tech-bulletin-2-2023-04-14",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Tech Bulletin",
            "description": "Whether you’re already familiar with Kadena or just learning about it for the first time, the Kadena Tech Bulletin provides a short technical overview of how we are revolutionizing the blockchain industry one block at a time. From Pact to Chainweb to how we are refining our builder onboarding process, we’ll be providing our community of builders and developers with all the updates and tools to help grow and scale their projects in our ever-growing ecosystem.",
            "menu": "Kadena Tech Bulletin",
            "label": "Kadena Tech Bulletin",
            "publishDate": "2023-04-14T00:00:00.000Z",
            "headerImage": "/assets/blog/1_YPQLz17cpWq-z2DKCwGR3g.webp",
            "tags": [
              "kadena",
              "walletconnect",
              "academy"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 507,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/kadena-tech-bulletin-3-2023-05-16",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Tech Bulletin",
            "description": "Whether you’re already familiar with Kadena or just learning about it for the first time, the Kadena Tech Bulletin provides a short technical overview of how we are revolutionizing the blockchain industry one block at a time. From Pact to Chainweb to how we are refining our builder onboarding process, we’ll be providing our community of builders and developers with all the updates and tools to help grow and scale their projects in our ever-growing ecosystem.",
            "menu": "Kadena Tech Bulletin",
            "label": "Kadena Tech Bulletin",
            "publishDate": "2023-05-16T00:00:00.000Z",
            "headerImage": "/assets/blog/1_LcO_epRtsyr13yM1hXTasQ.webp",
            "tags": [
              "kadena",
              "pact",
              "cli",
              "academy"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 842,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/kadena-tech-bulletin-4-2023-06-20",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Tech Bulletin",
            "description": "The Internet of Things (IoT) has become a buzzword in the technology industry in recent years. It refers to the interconnected network of devices, sensors, and systems that are able to communicate with each other, collect and share data, and perform automated actions without human intervention. This technology has the potential to revolutionize many industries, from healthcare to transportation, and has already started to transform our daily lives in numerous ways.",
            "menu": "Kadena Tech Bulletin",
            "label": "Kadena Tech Bulletin",
            "publishDate": "2023-06-20T00:00:00.000Z",
            "headerImage": "/assets/blog/1_2SE_f06Kj-A0xvlHr0XKIg.webp",
            "tags": [
              "kadena",
              "fungible contracts",
              "pact",
              "marmalade"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 779,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/kadenas-walletconnect-specification-2023-03-28",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena’s WalletConnect Specification",
            "description": "We are excited to announce that we have taken the next step in standardizing development on Kadena, which will significantly improve the development experience for our community of builders and developers. We recently merged KIP-17, which defines our standard for interacting with the WalletConnect signing API.",
            "menu": "Kadena’s WalletConnect Specification",
            "label": "Kadena’s WalletConnect Specification",
            "publishDate": "2023-03-28T00:00:00.000Z",
            "headerImage": "/assets/blog/1_qFkL2D2XFLbmCr3a-MI0_g.webp",
            "tags": [
              "kadena",
              "walletconnect"
            ],
            "author": "Jermaine Jong",
            "authorId": "jermaine.jong",
            "layout": "blog",
            "wordCount": 780,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/kip-0019-future-iteration-of-the-coin-and-fungible-contracts-2023-06-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "KIP-0019 - Future Iteration of the Coin and Fungible Contracts",
            "description": "If you’re keeping your finger on the pulse of all things Web3 and blockchain, you’ve heard all about smart wallets and how they’ve emerged as powerful and convenient tools for users. With their ability to seamlessly interact with decentralized applications (dApps), smart wallets are revolutionizing the way we engage with digital assets. Let’s explore a little deeper!",
            "menu": "KIP-0019 - Future Iteration of the Coin and Fungible Contracts",
            "label": "KIP-0019 - Future Iteration of the Coin and Fungible Contracts",
            "publishDate": "2023-06-06T00:00:00.000Z",
            "headerImage": "/assets/blog/1_dDdOhCBy_d7PrAe-xm8E2w.webp",
            "tags": [
              "kadena",
              "formal verification"
            ],
            "author": "Robert Soeldner",
            "authorId": "robert.soeldner",
            "layout": "blog",
            "wordCount": 715,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/language-server-support-for-pact-2023-04-18",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Language Server Support for Pact",
            "description": "Tools that support the development process of software are crucial for ensuring the quality, security, and timeliness of software. This is especially important in the context of smart contracts, which are self-executing programs in a distributed environment. As a result, smart contracts require a high level of security to protect against vulnerabilities that could compromise the integrity of the contract.",
            "menu": "Language Server Support for Pact",
            "label": "Language Server Support for Pact",
            "publishDate": "2023-04-18T00:00:00.000Z",
            "headerImage": "/assets/blog/1_NzViJSe3eJ45qJfeqLh1Lw.webp",
            "tags": [
              "pact"
            ],
            "author": "Robert Soeldner",
            "authorId": "robert.soeldner",
            "layout": "blog",
            "wordCount": 638,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/nft-collection-tutorial-on-marmalade-2023-01-25",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The NFT Collection Tutorial on Marmalade",
            "description": "Marmalade token policies allow for fine-grained customization of how NFTs are minted and sold. This article provides a tutorial demonstrating how an NFT collection supporting presale could be implemented in your NFT marketplace, using an example policy ‘simple-one-off-collection-policy`. This tutorial will demonstrate the policy step-by-step with an example collection called muppets-v1.",
            "menu": "The NFT Collection Tutorial on Marmalade",
            "label": "The NFT Collection Tutorial on Marmalade",
            "publishDate": "2023-01-25T00:00:00.000Z",
            "headerImage": "/assets/blog/1_0RpXuD_h3i9crcT6pRulPg.webp",
            "tags": [
              "marmalade"
            ],
            "author": "Heekyun",
            "authorId": "heekyun",
            "layout": "blog",
            "wordCount": 1963,
            "readingTimeInMinutes": 10,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/pact-4-6-is-in-pre-flight-2023-02-22",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact 4.6 is In (pre)Flight",
            "description": "Kadena is hard at work offering new and improved visions of the blockchain industry and its tooling. In particular, the Pact team is happy to announce improvements to the Kadena public blockchain Pact API in conjunction with developments and new additions to the language itself. As Kadena matures, we are bringing a new focus to the User Experience/Developer Experience of the platform and its tools, which includes envisioning future L2 solutions in the ecosystem. To initiate these efforts, Kadena presents the following new features",
            "menu": "Pact 4.6 is In (pre)Flight",
            "label": "Pact 4.6 is In (pre)Flight",
            "publishDate": "2023-02-22T00:00:00.000Z",
            "headerImage": "/assets/blog/1_BkKdH9y8UNpl4U5agsOesg.webp",
            "tags": [
              "pact",
              "zero knowledge",
              "formal verification"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 1059,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/pact-core-concepts-part-i-introduction-to-blockchain-development-with-kadena-2023-04-20",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact Core Concepts Part I — Introduction to Blockchain Development with Kadena",
            "description": "The Pact Core concepts series is a companion guide to the Real World Pact teaching repository. Written by Thomas Honeyman, a senior engineer at Awake Security, the series provides a first look at the essential concepts needed to write and test Pact programs on the scalable Chainweb blockchain. The series is a wonderful way to begin your Pact journey; after you’ve finished reading it, you are well-equipped to dive into the projects in the Real World Pact repository.",
            "menu": "Pact Core Concepts Part I",
            "label": "Pact Core Concepts Part I",
            "publishDate": "2023-04-20T00:00:00.000Z",
            "headerImage": "/assets/blog/1_HTwgnXLGl8yViDoeTNcGAQ.webp",
            "tags": [
              "pact"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 819,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/pact-core-concepts-part-ii-learn-pact-in-20-minutes-2023-04-27",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact Core Concepts Part II— Learn Pact in 20 Minutes",
            "description": "The Pact Core Concepts series is a companion guide to the Real World Pact repository, written by Thomas Honeyman, senior engineer at Awake Security. The series teaches the essential concepts needed to write and test Pact programs on the scalable Chainweb blockchain. Part II of the series, Learn Pact in 20 Minutes, is a crash course in the Pact programming language.",
            "menu": "Pact Core Concepts Part II",
            "label": "Pact Core Concepts Part II",
            "publishDate": "2023-04-27T00:00:00.000Z",
            "headerImage": "/assets/blog/1_IOeDK7eWYyl_w4yFdEF5vA.webp",
            "tags": [
              "pact"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 628,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/part-iii-of-the-pact-core-concepts-testing-and-formal-verification-in-the-pact-repl-2023-05-04",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact Core Concepts Part III — Testing and Formal Verification in the Pact REPL",
            "description": "The Pact Core Concepts series is a companion guide to the Real World Pact repository, written by Thomas Honeyman, a senior engineer at Awake Security. The series teaches the essential concepts needed to write and test Pact programs on the scalable Chainweb blockchain. Part III of the series, Testing and Formal Verification in the Pact REPL, teaches you how to secure your smart contracts.",
            "menu": "Pact Core Concepts Part III",
            "label": "Pact Core Concepts Part III",
            "publishDate": "2023-05-04T00:00:00.000Z",
            "headerImage": "/assets/blog/1_ZsQEhEAHC5wr3oj_kODDng.webp",
            "tags": [
              "pact",
              "formal verification"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 623,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/project-spotlight-kadenai-2023-08-15",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Project Spotlight - KadenAI",
            "description": "Today, we’re shining the spotlight on KadenAI, an innovative platform engineered to enhance the creator experience in the NFT space. KadenAI offers a suite of comprehensive tools designed to facilitate the creation of NFT collections. These tools include, but are not limited to, NFT minters, utility generators, and AI-powered image generation.",
            "menu": "Project Spotlight - KadenAI",
            "label": "Project Spotlight - KadenAI",
            "publishDate": "2023-08-15T00:00:00.000Z",
            "headerImage": "/assets/blog/2023/1_2TrpexM2c0w9JVwBL2JO9g.webp",
            "tags": [
              "marmalade"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 831,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/project-spotlight-swarms-finance-2023-08-11",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Project Spotlight - Swarms.Finance",
            "description": "Today, we’re shining the spotlight on Swarms.Finance! Swarms.Finance is a platform built on the Kadena blockchain, with a mission to transform Decentralized Autonomous Organizations (DAOs) within the world of decentralized finance (DeFi). The platform provides a comprehensive suite of tools and features for managing funds, investments, liquidity, swaps, payments, and purchases.",
            "menu": "Project Spotlight - Swarms.Finance",
            "label": "Project Spotlight - Swarms.Finance",
            "publishDate": "2023-08-11T00:00:00.000Z",
            "headerImage": "/assets/blog/2023/1_o2Ry6xVk_GnK-GvZrICtew.webp",
            "tags": [
              "swarms"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1026,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/randy-daal-chief-experience-officer-2023-05-05",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Randy Daal Chief Experience Officer",
            "description": "Kadena is extremely pleased to announce that Randy Daal has been promoted to Chief Experience Officer (CXO) of Kadena. Randy joined Kadena in April of 2022 as Kadena’s Developer Experience Lead. Prior to Kadena, Randy developed his passion in front-end development in several large companies in the Netherlands, including the creation of UpFront, a front-end consultancy company that later merged with Frontmen and then merged again with iO, one of the largest agencies in Europe. Randy has built many large-scale applications across a multitude of domains.",
            "menu": "Randy Daal",
            "label": "Randy Daal",
            "publishDate": "2023-05-05T00:00:00.000Z",
            "headerImage": "/assets/blog/1_I2xj4MFRpqxcHxy1QXuRIw.webp",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 608,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/spolight-on-linx-by-thinedge-labs-2023-07-13",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight on Linx by ThinEdge Labs",
            "description": "Today, we’re shining the spotlight on Linx, the first chain-less wallet building on Kadena. Linx is a revolutionary crypto wallet designed specifically for operating on the Kadena blockchain. With a vision to provide users with an intuitive and hassle-free experience, Linx strives to eliminate the complexities often associated with Web3 technologies. Simplicity and efficiency are important to Linx, which is why their wallet empowers users to accomplish their tasks with just a few taps, without the need for extensive technical knowledge. Say goodbye to the hurdles of the past and embrace a new era of user-centric crypto wallets with Linx.",
            "menu": "Spotlight on Linx by ThinEdge Labs",
            "label": "Spotlight on Linx by ThinEdge Labs",
            "publishDate": "2023-07-13T00:00:00.000Z",
            "headerImage": "/assets/blog/1_QXVZB4M1sQ9vOtgcwisIlg.webp",
            "tags": [
              "smart wallet"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 989,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/spotlight-on-kadena-mining-club-2023-04-11",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight on Kadena Mining Club",
            "description": "Today, we’re shining the spotlight on Kadena Mining Club (KMC) with founder Matthew Dunrya. Kadena Mining Club’s mission is to offer everyone an opportunity to mine cryptocurrency, specifically Kadena tokens (KDA), without the hassle of actually having to purchase miners and create a set-up for mining.",
            "menu": "Spotlight on Kadena Mining Club",
            "label": "Spotlight on Kadena Mining Club",
            "publishDate": "2023-04-11T00:00:00.000Z",
            "headerImage": "/assets/blog/1_uvrDltNpWnMpAt3ptGnk8A.webp",
            "tags": [
              "mining"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1455,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/spotlight-on-nopool-powered-by-massive-2023-02-23",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight on NoPool, Powered by Massive",
            "description": "Today, we are shining the spotlight on Massive, a company that’s bootstrapping a monetization alternative to online advertising. Massive’s SDK offers developers and their users the option of making money and paying with idle processing power, storage, and bandwidth rather than personal attention and data. 500,000-plus monthly active users have opted in with Massive and, together, form a supercomputer that compensates developers by hosting “massively” distributed projects. The company is funded by Point72 Ventures, Coinbase Ventures, Kraken Ventures, and other blockchain leaders.",
            "menu": "Spotlight on NoPool",
            "label": "Spotlight on NoPool",
            "publishDate": "2023-02-23T00:00:00.000Z",
            "tags": [
              "nopool"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1382,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/spotlight-on-tellor-2023-03-07",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight on Tellor",
            "description": "Today, we’re shining the spotlight on Tellor. Tellor is a decentralized oracle protocol that incentivizes an open, permissionless network of data reporting and data validation, ensuring that data can be provided by anyone and checked by everyone.",
            "menu": "Spotlight on Tellor",
            "label": "Spotlight on Tellor",
            "publishDate": "2023-03-07T00:00:00.000Z",
            "tags": [
              "oracle"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1045,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/the-advantages-of-kadenas-proof-of-work-mining-2023-02-03",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The Advantages of Kadena’s Proof-of-Work Mining",
            "description": "Proof of Work (PoW) is a consensus algorithm used in blockchain technology to validate transactions and produce new blocks. In PoW mining, “miners” compete to solve hard mathematical problems, and the first to solve a problem adds a new block to the chain and is rewarded with newly minted cryptocurrency.",
            "menu": "The Advantages of Kadena’s Proof-of-Work Mining",
            "label": "The Advantages of Kadena’s Proof-of-Work Mining",
            "publishDate": "2023-02-03T00:00:00.000Z",
            "headerImage": "/assets/blog/1_P58JAVT4RuGQg7ozeEtdKg.webp",
            "tags": [
              "kadena",
              "pow",
              "mining"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 476,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/the-kadena-tech-bulletin-2023-03-03",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Tech Bulletin",
            "description": "Whether you’re already familiar with Kadena or just learning about it for the first time, the Kadena Tech Bulletin provides a short technical overview of how we are revolutionizing the industry one block at a time. From Pact and Chainweb to how we are refining our builder onboarding process, we’ll be providing our community of builders and developers with all the updates and tools to help grow and scale the entire ecosystem.",
            "menu": "Tech Bulletin",
            "label": "Tech Bulletin",
            "publishDate": "2023-03-03T00:00:00.000Z",
            "tags": [
              "kadena",
              "chainweaver",
              "pact",
              "marmalade",
              "kadenajs",
              "chainweb",
              "community"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 789,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/the-kda-command-line-tools-new-release-for-kadenas-developers-and-builders-2023-05-24",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The KDA Command Line Tools New Release for Kadena’s Developers and Builders",
            "description": "We are thrilled to present and showcase the remarkable features of the latest release of KDA Command Line Tools, an all-in-one automation solution for transacting on the Kadena blockchain.",
            "menu": "The KDA Command Line Tools",
            "label": "The KDA Command Line Tools",
            "publishDate": "2023-05-24T00:00:00.000Z",
            "headerImage": "/assets/blog/1_rLMz_SpxPnaSj6t8vKSYiQ.webp",
            "tags": [
              "kda",
              "cli"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 430,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/top-5-real-world-use-cases-of-nfts-redefining-ownership-and-empowering-creators-with-marmalade-2023-07-27",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Top 5 Real World Use Cases of NFTs Redefining Ownership and Empowering Creators with Marmalade",
            "description": "Web3 is not only a finance revolution, it’s also a business evolution that harnesses powerful ideas such as the Wisdom of Crowds, composability, collaboration, decentralized storage, and headless branding. Prior to web3, these concepts were either impossible to implement or didn’t meet business standards. In this new paradigm, these ideas are multipliers that can launch web2 businesses into an ecosystem that is growing exponentially in every direction.",
            "menu": "Top 5 Real World Use Cases of NFTs Redefining Ownership and Empowering Creators with Marmalade",
            "label": "Top 5 Real World Use Cases of NFTs Redefining Ownership and Empowering Creators with Marmalade",
            "publishDate": "2023-07-27T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_O0A6f20g8Tmzq-Lv3z_NxA.webp",
            "tags": [
              "marmalade"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 894,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/top-web3-strategies-for-web2-companies-2023-01-27",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Top Web3 Strategies for Web2 Companies",
            "description": "Web3 is not only a finance revolution, it’s also a business evolution that harnesses powerful ideas such as the Wisdom of Crowds, composability, collaboration, decentralized storage, and headless branding. Prior to web3, these concepts were either impossible to implement or didn’t meet business standards. In this new paradigm, these ideas are multipliers that can launch web2 businesses into an ecosystem that is growing exponentially in every direction.",
            "menu": "Top Web3 Strategies for Web2 Companies",
            "label": "Top Web3 Strategies for Web2 Companies",
            "publishDate": "2023-01-27T00:00:00.000Z",
            "headerImage": "/assets/blog/1_AUUFCecs0s7MaKmMfKwPHQ.webp",
            "tags": [
              "web3"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1056,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/unlocking-the-value-of-smart-wallets-2023-06-28",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Unlocking the Value of Smart Wallets",
            "description": "If you’re keeping your finger on the pulse of all things Web3 and blockchain, you’ve heard all about smart wallets and how they’ve emerged as powerful and convenient tools for users. With their ability to seamlessly interact with decentralized applications (dApps), smart wallets are revolutionizing the way we engage with digital assets. Let’s explore a little deeper!",
            "menu": "Unlocking the Value of Smart Wallets",
            "label": "Unlocking the Value of Smart Wallets",
            "publishDate": "2023-06-28T00:00:00.000Z",
            "headerImage": "/assets/blog/1_eMeCKlWBLwPy-CvT6iLujw.webp",
            "tags": [
              "smart wallet"
            ],
            "author": "Ryan Levy",
            "authorId": "ryan.levy",
            "layout": "blog",
            "wordCount": 875,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2023/why-pact-is-the-best-defi-language-2023-01-05",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Why Pact is the Best DeFi Language",
            "description": "To say that 2022 has been a wild roller coaster ride for the Web3 and crypto industry as a whole is an understatement. Kadena has been pushing forward and growing beyond our expectations from hiring to engineering to business development. With our actively expanding team, Kadena strives to deliver a robust foundation of resources, content, and environment to support our expanding ecosystem of builders, projects, and users.",
            "menu": "Why Pact is the Best DeFi Language",
            "label": "Why Pact is the Best DeFi Language",
            "publishDate": "2023-01-05T00:00:00.000Z",
            "headerImage": "/assets/blog/1_LodIVJU_PvliNLDGsRZShQ.webp",
            "tags": [
              "pact"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 828,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/blogchain/2023",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "BlogChain 2023",
        "menu": "2023",
        "subTitle": "2023",
        "label": "2023",
        "order": 3,
        "description": "articles..articles...articles 2023",
        "layout": "home",
        "wordCount": 143,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/blogchain/2022/3-reasons-kadena-is-the-right-choice-for-crypto-builders-and-miners-2022-07-08",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "3 Reasons Kadena Is The Right Choice For Crypto Builders And Miners",
            "description": "Kadena is a unique open-source, public blockchain. Kadena’s entire architecture, from the blockchain technology to the smart contract language, has been built from the ground up, solving the blockchain trilemma of security, decentralization, and scalability — making it entirely possible for the next generation of the Internet to be built on Kadena!",
            "menu": "3 Reasons Kadena Is The Right Choice",
            "label": "3 Reasons Kadena Is The Right Choice",
            "publishDate": "2022-07-08T00:00:00.000Z",
            "tags": [
              "pact",
              "kda",
              "chainweb"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 705,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/4-ways-kadena-is-taking-blockchain-mainstream-2022-04-22",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "4 Ways Kadena Is Taking Blockchain Mainstream",
            "description": "Kadena founder Stuart Popejoy recently joined Okcoin for a Twitter Spaces chat in which he discussed numerous topics, including Kadena’s big plans to appeal to the masses.",
            "menu": "4 Ways Kadena Is Taking Blockchain Mainstream",
            "label": "4 Ways Kadena Is Taking Blockchain Mainstream",
            "publishDate": "2022-04-09T00:00:00.000Z",
            "tags": [
              "pact",
              "marmalade"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 763,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/a-step-by-step-guide-to-writing-pact-smart-contract-goliath-faucet-2022-10-04",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "A Step-By-Step Guide to Writing Pact Smart Contract — Goliath Faucet",
            "description": "The Kadena.js team has taken it upon themselves to create a step-by-step guide of the Goliath Project, including video demonstrations of the Goliath Wallet UI, summarizing a portion of Honeyman’s work, specifically with respect to the contract portion of the Goliath Project. The purpose of the step-by-step guide is to enable developers and interested individuals to start coding easily. For those interested in exploring the entire repo, please see Goliath Faucet Contract Overview and Goliath Faucet Main Contract.",
            "menu": "A Step-By-Step Guide to Writing Pact Smart Contract — Goliath Faucet",
            "label": "A Step-By-Step Guide to Writing Pact Smart Contract — Goliath Faucet",
            "publishDate": "2022-10-04T00:00:00.000Z",
            "headerImage": "/assets/blog/1_wmsX0LzHjaR7HVMUTjLqjw.webp",
            "tags": [
              "pact"
            ],
            "author": "Heekyun",
            "authorId": "heekyun",
            "layout": "blog",
            "wordCount": 6421,
            "readingTimeInMinutes": 33,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/anastasia-bez-kadenas-new-chief-operations-officer-2022-09-09",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Anastasia Bez Kadena’s New Chief Operating Officer",
            "description": "Kadena is extremely pleased to announce that Anastasia Bez has been promoted to Chief Operating Officer of Kadena. Anastasia was previously the Director of Operations and has been with Kadena since 2018. Before joining Kadena, Anastasia conducted research with the Center on National Security at Fordham Law School, where she also organized initiatives on geopolitics, cyber security, and foreign and domestic policy.",
            "menu": "Anastasia Bez",
            "label": "Anastasia Bez",
            "publishDate": "2022-09-09T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 481,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/between-the-block-doug-beardsley-2022-12-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Between the Blocks Doug Beardsley",
            "description": "Welcome to Kadena’s Personnel Series, where we showcase some of the most brilliant and talented minds behind Kadena! Since its inception in 2016, Kadena has continuously pushed the boundaries of innovation, being the only Layer 1 Proof-of-Work blockchain that has solved the Blockchain Trilemma. Kadena’s extraordinary achievements would not be possible without the hard work, visions and talent of its team members.",
            "menu": "Doug Beardsley",
            "label": "Doug Beardsley",
            "publishDate": "2022-12-06T00:00:00.000Z",
            "headerImage": "/assets/blog/1_c74yuQndgzdEYUcinKrTEA.webp",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 725,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/between-the-blocks-emily-pillmore-2022-11-02",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Between the Blocks Emily Pillmore",
            "description": "Welcome to Kadena’s Personnel Series, where we showcase some of the most brilliant and talented minds behind Kadena! Since its inception in 2016, Kadena has continuously pushed the boundaries of innovation, being the only Layer 1 Proof-of-Work blockchain that has solved the Blockchain Trilemma. Kadena’s extraordinary achievements would not be possible without the hard work, visions and talent of its team members.",
            "menu": "Emily Pillmore",
            "label": "Emily Pillmore",
            "publishDate": "2022-11-02T00:00:00.000Z",
            "headerImage": "/assets/blog/1_E0pjo9TdWL-oq_XvbjC4xA.webp",
            "tags": [
              "kadena",
              "pact"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1332,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/between-the-blocks-randy-daal-2022-10-19",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Between the Blocks Randy Daal",
            "description": "Welcome to Kadena’ Personnel Series, where we showcase some of the most brilliant and talented minds behind Kadena! Since its inception in 2016, Kadena has continuously pushed the boundaries of innovation, being the only Layer 1 Proof-of-Work blockchain that has solved the Blockchain Trilemma. Kadena’s extraordinary achievements would not be possible without the hard work, visions and talent of its team members.",
            "menu": "Between the Blocks Randy Daal",
            "label": "Between the Blocks Randy Daal",
            "publishDate": "2022-10-19T00:00:00.000Z",
            "headerImage": "/assets/blog/1_bwSQxDBogmkeytcc8tmMQw.webp",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1109,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/build-games-for-a-blockchain-future-with-kadena-2022-03-18",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Build Games For a Blockchain Future With Kadena",
            "description": "Ever since I was a little boy, I have always loved games. I spent my 5th-grade summer mapping the Dungeons of Skara Brae in Bard’s Tale on an Apple IIGS. Later I graduated to World of Warcraft on PC. Although my love for gaming never waned, I ended up working in finance. When I had the opportunity to change career paths, a dream came true. I joined Turbine, the video game developer behind Lord of the Rings Online, Dungeons and Dragons Online, and others.",
            "menu": "Build Games For a Blockchain Future With Kadena",
            "label": "Build Games For a Blockchain Future With Kadena",
            "publishDate": "2022-03-18T00:00:00.000Z",
            "headerImage": "/assets/blog/1_OKw9Caus7pvqToPXwLIG1g.webp",
            "tags": [
              "kadena",
              "web3"
            ],
            "author": "Dan Wiggins",
            "authorId": "dan.wiggins",
            "layout": "blog",
            "wordCount": 938,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/calling-web2-builders-kadena-eases-transition-to-web3-2022-03-09",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Calling Web2 Builders - Kadena Eases Transition to Web3",
            "description": "In March 2017, Kadena entered my radar when raising its seed round. Despite initial skepticism, I remarked to my partners at Asimov Ventures how impressed I was with Kadena’s software — it seemed to be addressing serious problems with Ethereum. When I subsequently met Kadena’s founders, Will Martino and Stuart Popejoy, I was blown away here were two brilliant programmers solving their own problems.",
            "menu": "Calling Web2 Builders - Kadena Eases Transition to Web3",
            "label": "Calling Web2 Builders - Kadena Eases Transition to Web3",
            "publishDate": "2022-03-09T00:00:00.000Z",
            "headerImage": "/assets/blog/1_jYzwXoAJq18vJgaOfl9rgA.webp",
            "tags": [
              "kadena",
              "chainweb"
            ],
            "author": "Tyler Benster",
            "authorId": "tyler.benster",
            "layout": "blog",
            "wordCount": 1758,
            "readingTimeInMinutes": 9,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/catching-up-with-cryptographer-computer-scientist-and-kadena-advisor-stuart-haber-2022-10-27",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Catching Up with Cryptographer, Computer Scientist and Kadena Advisor Stuart Haber",
            "description": "The blockchain and crypto industries have seen a lot of positive changes in recent years, with many professionals and enthusiasts developing new technologies and groundbreaking applications. Kadena has also experienced many significant changes and hit many groundbreaking milestones since its inception in 2016. So, we thought we would catch up with one of the blockchain industry pioneers, Stuart Haber, a renowned cryptographer and a Kadena advisor since 2018.",
            "menu": "Stuart Haber",
            "label": "Stuart Haber",
            "publishDate": "2022-10-27T00:00:00.000Z",
            "headerImage": "/assets/blog/1_leri5BWOzbsXmxjuycUX8w.webp",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1407,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/deprecation-notice-for-module-guards-and-pact-guards-2022-10-03",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Deprecation Notice for Module Guards and Pact Guards",
            "description": "Kadena aims to continue building and supporting our developer community with a robust, best-in-class experience for Web3 developers. In order to do so, the team at Kadena continues to provide developer updates swiftly to ensure a smooth builder experience. This article will inform you on how to migrate away from two guard types in Pact to safe alternatives. These deprecated guards will be removed in a future release.",
            "menu": "Deprecation Notice for Module Guards and Pact Guards",
            "label": "Deprecation Notice for Module Guards and Pact Guards",
            "publishDate": "2022-10-03T00:00:00.000Z",
            "headerImage": "/assets/blog/1_8sbZuCncPEgill19IVOSYQ.webp",
            "tags": [
              "kadena",
              "pact"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 1485,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/developer-experience-in-the-making-2022-11-09",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena.js - Developer Experience Update",
            "description": "We have been steadily growing an all-star team as our team needed to be up to par with our all-star core Haskellers at Kadena. We currently have a team of 7 developers working on dev experience, which will grow to 12 by the end of the year. Growing this team this fast already points out the importance of the developer experience for Kadena. There is a lot of great stuff coming to our ecosystem, so fasten your seatbelt because next year will be like “The Fast and the Furious — K-orbit” 🚀!!",
            "menu": "Kadena.js - Developer Experience Update",
            "label": "Kadena.js - Developer Experience Update",
            "publishDate": "2022-11-09T00:00:00.000Z",
            "headerImage": "/assets/blog/1_RYwfKuTY3PCXtd8wvbV6DQ.webp",
            "tags": [
              "kadena",
              "kadenajs",
              "marmalade"
            ],
            "author": "Randy Daal",
            "authorId": "randy.daal",
            "layout": "blog",
            "wordCount": 774,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/first-steps-a-new-developer-experience-starts-with-kadena-js-2022-06-15",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Eco is excited to present a new developer experience with Kadena.JS.",
            "description": "We’re on the verge of a new and improved front-end experience at Kadena! It’s time to let the community in on how our innovation network, Kadena Eco, is turbocharging R&D efforts to improve our front-end ecosystem and what lies ahead in the coming months. Because we believe that our community members can best help us when they are informed. So along with developing a stellar new front end, another key job is keeping our community apprised every step of the way.",
            "menu": "Kadena Eco is excited to present a new developer experience with Kadena.JS.",
            "label": "Kadena Eco is excited to present a new developer experience with Kadena.JS.",
            "publishDate": "2022-07-15T00:00:00.000Z",
            "headerImage": "/assets/blog/1_IlvgBc3Vwf6D4tc631_h2A.webp",
            "tags": [
              "kadenajs"
            ],
            "author": "Randy Daal",
            "authorId": "randy.daal",
            "layout": "blog",
            "wordCount": 820,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/from-haskell-to-pact-my-journey-in-code-toward-a-more-stable-and-secure-environment-for-blockchain-builders-2022-07-01",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "From Haskell to Pact - My Journey in Code Toward a More Stable and Secure Environment for Blockchain Builders",
            "description": "As a programmer for the past three decades, I’ve seen a lot of epic changes in technology — from my early days writing C++ parsers for Borland at the dawn of the internet to surfing the Web 2.0 wave with Java J2EE-based web applications and microservices on Haskell. In the last decade I’ve migrated fully to functional programming, building both production systems in Haskell and formally verified models in Coq.",
            "menu": "From Haskell to Pact - My Journey in Code Toward a More Stable and Secure Environment for Blockchain Builders",
            "label": "From Haskell to Pact - My Journey in Code Toward a More Stable and Secure Environment for Blockchain Builders",
            "publishDate": "2022-07-01T00:00:00.000Z",
            "headerImage": "/assets/blog/1_VuAQP0wMbSn4odUtYSg97w.webp",
            "tags": [
              "pact"
            ],
            "author": "John Wiegley",
            "authorId": "john.wiegley",
            "layout": "blog",
            "wordCount": 1568,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/how-kadena-is-reimagining-blockchain-developer-ux-2022-06-09",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "How Kadena is Reimagining Blockchain Developer UX",
            "description": "The primary focus of Kadena these last few years has been to create a state-of-the-art first layer blockchain development solution. In that quest, we’re not ashamed to admit that we’ve also gone big and bold by setting out to completely revolutionize the blockchain world.",
            "menu": "How Kadena is Reimagining Blockchain Developer UX",
            "label": "How Kadena is Reimagining Blockchain Developer UX",
            "publishDate": "2022-06-09T00:00:00.000Z",
            "headerImage": "/assets/blog/1_q5vogZ5itWngvqAHv9_Zbg.webp",
            "tags": [
              "kadena"
            ],
            "author": "Randy Daal",
            "authorId": "randy.daal",
            "layout": "blog",
            "wordCount": 1139,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/introducing-kadena-ecos-inaugural-grant-cohort-2022-07-26",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Introducing Kadena Eco’s Inaugural Grant Cohort",
            "description": "In April, Kadena Eco announced its grants program, spurring countless conversations with founders with big ideas for building on Kadena. Our team was blown away and at times overwhelmed by the volume and quality of applications over the past few months. We’re now ready to share our first cohort of grant recipients — and more on why we selected the grantees that we did.",
            "menu": "Introducing Kadena Eco",
            "label": "Introducing Kadena Eco",
            "publishDate": "2022-07-26T00:00:00.000Z",
            "tags": [
              "grant"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 856,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/john-wiegley-chief-technology-officer-of-kadena-2022-10-05",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "John Wiegley Chief Technology Officer of Kadena",
            "description": "Kadena is extremely thrilled to announce that John Wiegley has been promoted to Chief Technology Officer! John was previously Kadena’s Lead Architect/Engineer where his primary role was to learn the ins and outs of the Kadena system with a core focus on PACT development while supporting a range of other technology priorities.",
            "menu": "John Wiegley",
            "label": "John Wiegley",
            "publishDate": "2022-10-05T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 528,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadena-2022-year-in-review-2022-12-22",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena 2022 Year In Review",
            "description": "To say that 2022 has been a wild roller coaster ride for the Web3 and crypto industry as a whole is an understatement. Kadena has been pushing forward and growing beyond our expectations from hiring to engineering to business development. With our actively expanding team, Kadena strives to deliver a robust foundation of resources, content, and environment to support our expanding ecosystem of builders, projects, and users.",
            "menu": "Kadena 2022 Year In Review",
            "label": "Kadena 2022 Year In Review",
            "publishDate": "2022-12-22T00:00:00.000Z",
            "headerImage": "/assets/blog/1_u3HlSK6n4qUw9frTiGjq_g.webp",
            "tags": [
              "kadena",
              "grants"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 2110,
            "readingTimeInMinutes": 11,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadena-2023-live-technical-road-map-2022-12-15",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena 2023 Live Technical Roadmap",
            "description": "Since Kadena’s mainnet launch in January 2020, our team and community have grown tremendously. Our ecosystem experienced exponential growth with several hundred projects now building on the Kadena blockchain. Kadena’s massive growth could only be accomplished with the help of our amazing community, ecosystem of partners, builders, and ambassadors! Thank you everyone for accompanying us through this journey!",
            "menu": "Kadena 2023 Live Technical Roadmap",
            "label": "Kadena 2023 Live Technical Roadmap",
            "publishDate": "2022-12-15T00:00:00.000Z",
            "headerImage": "/assets/blog/1_eguMp-5U0vl9Za5LkYNiCw.webp",
            "tags": [
              "kadena",
              "pact",
              "chainweb"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 1480,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadena-commitment-to-builders-2022-05-27",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Commitment To Builders",
            "description": "Kadena is the blockchain for builders — the people who are building the next generation of the Internet. Whether you’re new to Web3 or an experienced Web3 developer who’s been impacted by recent events in the crypto industry, we’re here to help. This is a moment of reckoning. Not just for builders, but for the crypto community as a whole.",
            "menu": "Kadena Commitment To Builders",
            "label": "Kadena Commitment To Builders",
            "publishDate": "2022-05-27T00:00:00.000Z",
            "headerImage": "/assets/blog/0_egllSaAanOmAOb8_.png",
            "tags": [
              "kadena",
              "grant"
            ],
            "author": "Francesco Melpignano",
            "authorId": "francesco.melpignano",
            "layout": "blog",
            "wordCount": 852,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadena-eco-core-telegram-ama-transcript-2022-08-12",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Eco & Core Telegram AMA, August 11, 2022 Transcript",
            "description": "Welcome everyone, to the return of Kadena’s Telegram AMA! Compared to last year, we have a full suite of amazing team members joining us today for this special AMA session! Without further ado, I’ll let the team introduce themselves to the existing community members and anyone new tuning in!",
            "menu": "AMA, August 11, 2022 Transcript",
            "label": "AMA, August 11, 2022 Transcript",
            "publishDate": "2022-08-12T00:00:00.000Z",
            "tags": [
              "kadena",
              "grant"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 3128,
            "readingTimeInMinutes": 16,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadena-eco-grants-2022-04-21",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Eco Grants - What You Need To Know",
            "description": "Create something new — for yourself and the world Blockchain is one of the most significant technologies of our time. In fact, it’s essential as we move into a world that is increasingly digital. That’s why today, we’ve launched a $100 million Grant Program to inspire builders to come and innovate on the Kadena network.",
            "menu": "Kadena Eco Grants - What You Need To Know",
            "label": "Kadena Eco Grants - What You Need To Know",
            "publishDate": "2022-04-21T00:00:00.000Z",
            "headerImage": "/assets/blog/0_32R3zmCL7LfiYyED.png",
            "tags": [
              "kadena",
              "grant"
            ],
            "author": "Francesco Melpignano",
            "authorId": "francesco.melpignano",
            "layout": "blog",
            "wordCount": 886,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadena-eco-office-hours-transcript-2022-07-22",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Eco Office Hours Transcript",
            "description": "Hey everyone. Welcome to Kadena Eco’s first Office Hours. We’ve heard the community and wanted to give everyone an update about Kadena Eco’s inception earlier this year. These spaces will kind of provide the community with a chance to ask any questions they want about what Kadena Eco has been doing in terms of grants, hiring, and developer improving the developer experience like Kadena.js.",
            "menu": "Kadena Eco Office Hours Transcript",
            "label": "Kadena Eco Office Hours Transcript",
            "publishDate": "2022-07-22T00:00:00.000Z",
            "tags": [
              "kadena",
              "grant"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 8554,
            "readingTimeInMinutes": 43,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadena-eco-onboards-strategic-advisory-board-to-fuel-growth-2022-08-31",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Eco Onboards Strategic Advisory Board to Fuel Growth",
            "description": "From Day 1, Kadena and Kadena Eco have been the leading forces in Blockchain focused on builders. Today, we announce the formation of a Strategic Advisory Board, uniting technical founders and entrepreneurs with the world’s top blockchain leaders, venture capitalists, and acceleration partners to support startups at every phase of their development journey.",
            "menu": "Kadena Eco Onboards Strategic Advisory Board to Fuel Growth",
            "label": "Kadena Eco Onboards Strategic Advisory Board to Fuel Growth",
            "publishDate": "2022-08-31T00:00:00.000Z",
            "headerImage": "/assets/blog/1_GKYqAg6WO1MEc4z5l7Kx2A.webp",
            "tags": [
              "kadena",
              "grant"
            ],
            "author": "Francesco Melpignano",
            "authorId": "francesco.melpignano",
            "layout": "blog",
            "wordCount": 345,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadena-eco-supercharges-kadena-ecosystem-2022-04-02",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Eco Supercharges Kadena Ecosystem",
            "description": "When we look back on the evolution of the blockchain industry 10 years from now, I believe that 2021 will stand out as a major inflection point. It was the first year that the blockchain world noticed that Kadena had solved the biggest problem in the industry scaling the proof of work consensus method to meet global transaction loads without sacrificing decentralization and openness.",
            "menu": "Kadena Eco Supercharges Kadena Ecosystem",
            "label": "Kadena Eco Supercharges Kadena Ecosystem",
            "publishDate": "2022-04-02T00:00:00.000Z",
            "headerImage": "/assets/blog/1_XNTbZovY5Di-8JIN2a5W3g.webp",
            "tags": [
              "kadena",
              "grant"
            ],
            "author": "Doug Beardsley",
            "authorId": "doug.beardsley",
            "layout": "blog",
            "wordCount": 851,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadena-js-pactnumber-2022-09-09",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena.js — PactNumber has been Released",
            "description": "We are thrilled to announce that PactNumber is now released in Kadena.js. What is PactNumber and how is it used? PactNumber is a typescript class that provides useful number functions for frontend builders to generate Pact Code conveniently with accuracy. In this article, we’ll take a look at the use of numbers in KDA transfer functions and introduce the usage of PactNumber.",
            "menu": "Kadena.js — PactNumber has been Released",
            "label": "Kadena.js — PactNumber has been Released",
            "publishDate": "2022-09-09T00:00:00.000Z",
            "tags": [
              "kadenajs",
              "kda"
            ],
            "author": "Heekyun",
            "authorId": "heekyun",
            "layout": "blog",
            "wordCount": 581,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadena-telegram-ama-with-binance-exchange-2022-05-03",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Telegram AMA with Binance Exchange, May 3 2022 Transcript",
            "description": "Welcome to a special AMA with the Kadena team! It is my pleasure to introduce to you Stuart Popejoy, @SirlensAlot, who is the Kadena CEO. Joining him is Doug Beardsley, @mightybyte, Kadena’s Director of Engineering!",
            "menu": "Kadena Telegram AMA with Binance Exchange",
            "label": "Kadena Telegram AMA with Binance Exchange",
            "publishDate": "2022-05-04T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 4403,
            "readingTimeInMinutes": 23,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/kadenas-community-powered-developer-documentation-2022-02-11",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena’s Community-Powered Developer Documentation",
            "description": "Entering 2022, the Kadena ecosystem is going into overdrive, so it’s critical that our developer documentation keep up. We’re thrilled to announce a major refresh of the Kadena developer documentation hub to supercharge builder’s access to information. What’s more, the docs are now fully community-powered, open- and crowd-sourced, tapping the incredible resources in our community to keep everything up-to-date and accurate.",
            "menu": "Kadena’s Community-Powered Developer Documentation",
            "label": "Kadena’s Community-Powered Developer Documentation",
            "publishDate": "2022-02-11T00:00:00.000Z",
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1114,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/pact-4-2-0-blazes-to-mainnet-2022-01-18",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact 4.2.0 Blazes to Mainnet!",
            "description": "At Kadena, we strive for delivering continued improvements to better our user experience in building on our platform. With Pact at the forefront of safe, expressive and performant smart contracts, we are pleased to announce the release of Pact 4.2.0! This version adds anonymous “lambda” functions, new natives for improved user experience, improvements to persistence, and various bugfixes that were weeded out.",
            "menu": "Pact 4.2.0 Blazes to Mainnet!",
            "label": "Pact 4.2.0 Blazes to Mainnet!",
            "publishDate": "2022-01-19T00:00:00.000Z",
            "headerImage": "/assets/blog/1_QEGOGwBeXw78S3eV4V-IDA.webp",
            "tags": [
              "pact"
            ],
            "author": "Jose Cardona",
            "authorId": "jose.cardona",
            "layout": "blog",
            "wordCount": 1172,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/proof-of-work-vs-proof-of-stake-kadenas-advantages-explained-2022-12-08",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Proof of Work vs Proof of Stake, Kadena’s Advantages Explained",
            "description": "Kadena is currently the only blockchain on a proof-of-work model that can expand to handle global transaction volumes. This makes it scalable, a difficult feat to accomplish. This forms the building blocks of Kadena’s ecosystem, verifying transactions in a more resilient manner that gives developers room to flex up capacity when their projects take off.",
            "menu": "Proof of Work vs Proof of Stake, Kadena’s Advantages Explained",
            "label": "Proof of Work vs Proof of Stake, Kadena’s Advantages Explained",
            "publishDate": "2022-12-08T00:00:00.000Z",
            "headerImage": "/assets/blog/1_JzSicHPhcWHotlKMuXQTlA.webp",
            "tags": [
              "pow"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 541,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/release-of-kadena-client-interacting-with-the-kadena-blockchain-2022-11-04",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Release of @kadena/client - Interacting with the Kadena Blockchain",
            "description": "The Kadena.js team has created a library that allows Javascript/Typescript users to easily interact with the Kadena Blockchain. Creating contracts is explicitly left out of the library as it is much morecomplicated to transpile Javascript to Pact.",
            "menu": "Release of @kadena/client - Interacting with the Kadena Blockchain",
            "label": "Release of @kadena/client - Interacting with the Kadena Blockchain",
            "publishDate": "2022-11-04T00:00:00.000Z",
            "headerImage": "/assets/blog/1_dAoWAzGntfMI0pKJbVSEhw.webp",
            "tags": [
              "pact"
            ],
            "author": "Albert Groothedde",
            "authorId": "albert.g",
            "layout": "blog",
            "wordCount": 1827,
            "readingTimeInMinutes": 10,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/scott-barker-2022-09-22",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Eco Welcomes New Strategic Advisor",
            "description": "We are excited to announce that Scott Barker, partner and co-founder of GTMfund, has recently been inaugurated to the Kadena family as one of Kadena’s new strategic advisors. Scott brings with him a diverse background in sales, go-to-marketing and an extensive network of relationships that can support Kadena’s rapid hypergrowth and mass adoption plans.",
            "menu": "Kadena Eco Welcomes New Strategic Advisor",
            "label": "Kadena Eco Welcomes New Strategic Advisor",
            "publishDate": "2022-09-22T00:00:00.000Z",
            "tags": [
              "grant"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1309,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/spotlight-on-crankk-2022-08-03",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight On Crankk",
            "description": "Today, we’re shining the spotlight on Crankk, A community-founded project that has developed distributed wireless networks that provide coverage for IoT devices such as smart meters and GPS trackers. Using Kadena’s low gas fees and its secure and high throughput Proof-of-Work network, Crankk plans to build a community network for LoRaWan coverage with better transparency and with checks running through Pact.",
            "menu": "Spotlight On Crankk",
            "label": "Spotlight On Crankk",
            "publishDate": "2022-08-03T00:00:00.000Z",
            "tags": [
              "pow"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 819,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/spotlight-on-dna-2022-06-24",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight On DNA",
            "description": "Database of Native Assets (DNA) is a blockchain-based platform, built on Kadena, that helps brands combat counterfeiting and build trust with their customers. Abraham Milano, Adam Joannou & Douglas Jakobi co-founded DNA in 2021 as a token-based bridge between the physical and digital worlds that allows creators to mint their own branded DNA tokens that prove their product’s provenance and authenticity, reducing counterfeiting risk in the process.",
            "menu": "Spotlight On DNA",
            "label": "Spotlight On DNA",
            "publishDate": "2022-06-24T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1062,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/spotlight-on-electron-labs-2022-07-20",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight On Electron Labs",
            "description": "Today, we’re shining the spotlight on Electron Labs, a zero-knowledge (ZK) technology company working to make ZK infrastructure ready for mass adoption. Last week, Electron announced that it will provide its cloud-based ZK infrastructure to power the rollups technology on the Kadena blockchain.",
            "menu": "Spotlight On Electron Labs",
            "label": "Spotlight On Electron Labs",
            "publishDate": "2022-07-20T00:00:00.000Z",
            "tags": [
              "zero knowledge"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 755,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/spotlight-on-eucalyptus-labs-2022-09-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight On Eucalyptus Labs",
            "description": "Today, we’re shining the spotlight on Eucalyptus Labs, a software development company focused on shipping products and adding support in two key areas, developer UX and infrastructure for the Kadena Ecosystem. We recently spoke with Koby Lazar, Eucalyptus Lab’s founder and CEO, about their project and how they’re working on improving Kadena’s ecosystem through their goals.",
            "menu": "Spotlight On Eucalyptus Labs",
            "label": "Spotlight On Eucalyptus Labs",
            "publishDate": "2022-09-06T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1240,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/spotlight-on-hypercent-2022-08-24",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight On Hypercent",
            "description": "Today, we’re shining the spotlight on Hypercent, another community-based project that is driving user adoption by helping verified projects launch on Kadena through their innovative launchpad platform and their upcoming NFT marketplace built using Kadena’s NFT standard, Marmalade.",
            "menu": "Spotlight On Hypercent",
            "label": "Spotlight On Hypercent",
            "publishDate": "2022-08-24T00:00:00.000Z",
            "tags": [
              "marmalade"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1539,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/spotlight-on-kalend-2022-07-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight On Kalend",
            "description": "Today, we’re profiling Kalend Finance, a next-gen lending protocol. Kalend creates properly functioning lending and borrowing pools for Kadena assets, and each pool has interest rates that are determined by the supply and demand of the underlying asset. The result is a unique, two-sided approach to lending that dynamically calculates a borrower’s borrowing capacity.",
            "menu": "Spotlight On Kalend",
            "label": "Spotlight On Kalend",
            "publishDate": "2022-07-06T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 870,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/spotlight-on-lago-finance-2022-06-16",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight On Lago Finance",
            "description": "Today, we’re profiling Lago Finance, an innovative first mover co-founded by Matthew Teeter and Sergio Mello, whose mission is to build the first Kadena-native decentralized stablecoin. We recently caught up with Matthew and Sergio about their vision for the future of decentralized finance, and why they chose to build their foundational DeFi infrastructure on Kadena.",
            "menu": "Spotlight On Lago Finance",
            "label": "Spotlight On Lago Finance",
            "publishDate": "2022-06-16T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1436,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/spotlight-on-unmarshal-2022-09-21",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Spotlight On Unmarshal",
            "description": "Today, we’re shining the spotlight on Unmarshal, who is providing multi-chain data infrastructure on Kadena and offering simplified access to DeFi, NFT, and Metaverse data. Unmarshal’s data indexing protocol will allow builders to seamlessly access on-chain data for DeFi applications!",
            "menu": "Spotlight On Unmarshal",
            "label": "Spotlight On Unmarshal",
            "publishDate": "2022-09-21T00:00:00.000Z",
            "tags": [
              "defi"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1214,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/the-current-state-of-marmalade-2022-06-29",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The Current State of Marmalade",
            "description": "Marmalade is the new Kadena standard for NFTs, addressing long-standing concerns plaguing NFT markets today, like the inability to enforce requirements (i.e., royalties) on the sale of an NFT. We’d like to update our incredible community of builders on Marmalade and our roadmap for the future.",
            "menu": "The Current State of Marmalade",
            "label": "The Current State of Marmalade",
            "publishDate": "2022-06-29T00:00:00.000Z",
            "headerImage": "/assets/blog/1_sWZGaZatGNQgUoioo9_B0w.webp",
            "tags": [
              "marmalade"
            ],
            "author": "Randy Daal",
            "authorId": "randy.daal",
            "layout": "blog",
            "wordCount": 491,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/the-future-of-multichain-2022-04-19",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The Future of Multichain",
            "description": "At Kadena, we like to say that our users “live in the future” because every day they leverage advanced cross-chain bridge technology just by using and trading KDA! Kadena’s scalability joins multiple independent chains like lanes on a freeway. However, unlike a real freeway, we can add more lanes anytime, so there are no “traffic jams” to drive up gas prices and slow down dapps, like we see on Ethereum and other unscalable layer-1s. The future of blockchain is a multi-chain protocol and it’s currently being realized today.",
            "menu": "The Future of Multichain",
            "label": "The Future of Multichain",
            "publishDate": "2022-04-19T00:00:00.000Z",
            "headerImage": "/assets/blog/1_DPNo47Y2B1zwEMGSA_E-gA.webp",
            "tags": [
              "kda"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 1174,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/the-story-of-kadenas-proof-of-work-blockchain-2022-10-13",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The Story of Kadena’s Proof of Work Blockchain",
            "description": "Since its inception in 2016, Kadena has continuously innovated and achieved tremendous milestones, making it the first and only Layer-1 blockchain that has managed to permanently address scalability while preserving the power of Proof-of-Work (PoW) security and decentralization. It is the only Layer-1 blockchain to have solved the Blockchain Trilemma.",
            "menu": "The Story of Kadena’s Proof of Work Blockchain",
            "label": "The Story of Kadena’s Proof of Work Blockchain",
            "publishDate": "2022-10-13T00:00:00.000Z",
            "headerImage": "/assets/blog/0_slJi3XAk5a2usmEu.png",
            "tags": [
              "pow",
              "kda"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 866,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/token-protocol-on-marmalade-2022-12-23",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Token Protocol on Marmalade",
            "description": "To end 2022 with a bang, we are excited to announce our last feature upgrade of the year! The Marmalade team at Kadena has worked hard and is now rolling out an upgrade to the Marmalade contract with a new feature ttoken protocol. This new token protocol will increase safety for our developers during the lazy minting process! Let’s dive right in.",
            "menu": "Token Protocol on Marmalade",
            "label": "Token Protocol on Marmalade",
            "publishDate": "2022-12-23T00:00:00.000Z",
            "headerImage": "/assets/blog/1_PMdTOo8SNitmuC9rU75ahg.webp",
            "tags": [
              "marmalade"
            ],
            "author": "Heekyun",
            "authorId": "heekyun",
            "layout": "blog",
            "wordCount": 586,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/turbocharging-mainstream-adoption-with-kadena-eco-2022-02-15",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Turbocharging mainstream adoption with Kadena Eco",
            "description": "We can all look back at 2021 as the year that put Kadena on the map as a compelling alternative for truly decentralized, scalable and secure layer-1 blockchain technology. As 2022 unfolds we want to give you, our bustling community, a preview of what’s next. Following the development and release of more groundbreaking innovations than any other competing platform in the market, Kadena is poised to make major investments to grow and empower our ecosystem of builders leveraging these paradigm-shifting technologies.",
            "menu": "Turbocharging mainstream adoption with Kadena Eco",
            "label": "Turbocharging mainstream adoption with Kadena Eco",
            "publishDate": "2022-02-15T00:00:00.000Z",
            "headerImage": "/assets/blog/1_TaVjEcnJO4qg0ywu08p_qw.webp",
            "tags": [
              "web3",
              "grant"
            ],
            "author": "Francesco Melpignano",
            "authorId": "francesco.melpignano",
            "layout": "blog",
            "wordCount": 1689,
            "readingTimeInMinutes": 9,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/whats-new-in-chainweb-2-17-2022-11-30",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "What’s new in Chainweb 2.17",
            "description": "Kadena is releasing a new version of Chainweb Node, version 2.17 which will have a service date in effect as of 2022–12–01T00:00:00Z. In addition to various bug fixes and performance optimizations, this release will change the current Pact and Chainweb Node experience for some dApp developers and users. In this article, we will explain the UX/DX-relevant changes in depth, and provide a migration path.",
            "menu": "What’s new in Chainweb 2.17",
            "label": "What’s new in Chainweb 2.17",
            "publishDate": "2022-11-30T00:00:00.000Z",
            "headerImage": "/assets/blog/1_ZKcQU0DnPml7EiRCvMoxGg.webp",
            "tags": [
              "chainweb"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 634,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2022/whats-new-in-pact-4-4-2022-08-31",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "What’s New in Pact 4.4",
            "description": "Every growing decentralized community needs builders. With the new cohorts of grantees selected by Kadena Eco being announced every week, the Pact engineering team has been hard at work soliciting feedback and developing features for dApp developers to build their projects with more security, robustness, and confidence than ever before. Pact 4.4 brings major improvements in functionality, auditability, and transparency — primitives for building the decentralized economies and marketplaces that continue to dominate crypto.",
            "menu": "What’s New in Pact 4.4",
            "label": "What’s New in Pact 4.4",
            "publishDate": "2022-08-31T00:00:00.000Z",
            "headerImage": "/assets/blog/1_IW4RipwJLD_0U4n4O6_MlA.webp",
            "tags": [
              "pact"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 719,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/blogchain/2022",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "BlogChain 2022",
        "menu": "2022",
        "subTitle": "2022",
        "label": "2022",
        "order": 3,
        "description": "articles..articles...articles 2022",
        "layout": "home",
        "wordCount": 143,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/blogchain/2021/2021-year-in-review-2021-12-31",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "2021 Year In Review",
            "description": "To everybody that has joined the Kadena community this year we want to give a hearty thanks for going on this journey with us! With that in mind, here are the highlights of a truly incredible year for Kadena as we made huge progress defining and executing on our vision. We couldn’t have done it without the help of our tremendous community and ecosystem of partners, builders, and ambassadors!",
            "menu": "2021 Year In Review",
            "label": "2021 Year In Review",
            "publishDate": "2021-12-31T00:00:00.000Z",
            "headerImage": "/assets/blog/1_2140ssAmZmFe0EWflQspAQ.webp",
            "tags": [
              "marmalade",
              "pact"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 1863,
            "readingTimeInMinutes": 10,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/announcing-the-kadena-chain-relay-2021-03-25",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Announcing the Kadena Chain Relay",
            "description": "Today, we deployed the beta smart contract of the Kadena Chain Relay into testnet. The chain relay provides economic security through bonded KDA for our Ethereum, Celo and Terra decentralized bridges. In this post, we describe how participants can bond KDA to operate and validate the Chain Relay.",
            "menu": "Announcing the Kadena Chain Relay",
            "label": "Announcing the Kadena Chain Relay",
            "publishDate": "2021-03-25T00:00:00.000Z",
            "headerImage": "/assets/blog/1_hFmZHqA2HYLgPUAQgVxlog.webp",
            "tags": [
              "kda"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 881,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/chain-relay-app-testnet-tournament-2021-08-26",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Chain Relay App - Testnet Tournament",
            "description": "With the testnet launch of Kadena’s Chain Relay App, we’re kicking off a Testnet Tournament to see who can redeem the most testnet KDA (tKDA) from running the relay app! With the potential to earn over 10,000 KDA, read this quick article on the objectives and rules of this tournament to increase your chances of earning the most KDA! before launching the only scalable POW public blockchain in 2020.",
            "menu": "Testnet Tournament",
            "label": "Testnet Tournament",
            "publishDate": "2021-08-26T00:00:00.000Z",
            "tags": [
              "kda"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 747,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/chain-relay-bonding-launch-2021-07-02",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Chain Relay Bonding Launch",
            "description": "Learn how you can help secure the Kadena Chain Relay by bonding KDA! Today, the Kadena Chain Relay Bonding Program launches on Kadena Mainnet and is ready to accept bonders. This is an important first step to establish robust economic security for bridging activities like wrapping Ethereum tokens on Kadena.",
            "menu": "Chain Relay Bonding Launch",
            "label": "Chain Relay Bonding Launch",
            "publishDate": "2021-07-02T00:00:00.000Z",
            "headerImage": "/assets/blog/1_-YDXCeAfa2h-FyBY4xzE3A.webp",
            "tags": [
              "chainweb"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 680,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/get-to-know-pact-4-2021-06-17",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Get to know Pact 4!",
            "description": "Smart contracts are all about making things happen — every transaction on the blockchain records assets changing hands, or community members committing to support a project. With Pact 4 the safest and easiest smart contract language gains powerful new features to ensure apps ship with the most security, transparency and kickass functionality possible. With new community-driven primitive ops, better cross-chain and event support, and code coverage, Pact 4 is the most productive smart contract language ever.",
            "menu": "Get to know Pact 4!",
            "label": "Get to know Pact 4!",
            "publishDate": "2021-06-17T00:00:00.000Z",
            "headerImage": "/assets/blog/1_qYmdUAxT3iqFnIlJSQ_YYw.webp",
            "tags": [
              "pact"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 1280,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/getting-started-with-chainweb-relay-app-2021-08-25",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Getting Started with Kadena Relay App in Testnet",
            "description": "Part 1 Create and fund a testnet KDA account. Part 2 Create a Bond on Kadena Testnet. Part 3 Install and Run Kadena Relay App on Testnet. Part 4 (bonus) Rotate, renew, and unbond your bonds.",
            "menu": "Getting Started with Kadena Relay App in Testnet",
            "label": "Getting Started with Kadena Relay App in Testnet",
            "publishDate": "2021-08-25T00:00:00.000Z",
            "headerImage": "/assets/blog/1_bmXFrJ6AX3NxWty7Au7sVg.webp",
            "tags": [
              "chainweb"
            ],
            "author": "Heekyun",
            "authorId": "heekyun",
            "layout": "blog",
            "wordCount": 998,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/how-to-scale-a-proof-of-work-blockchain-2021-03-07",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "How to Scale a Proof of Work Blockchain",
            "description": "Let’s start with the classic Computer Science parallelization and work from there. If one Bitcoin blockchain can do 5 transactions per second (using round number approximations for simplicity), two Bitcoin blockchains can do 10 transactions per second, ten blockchains can do 50 tps, etc. But this approach has two major problems",
            "menu": "How to Scale a Proof of Work Blockchain",
            "label": "How to Scale a Proof of Work Blockchain",
            "publishDate": "2021-03-07T00:00:00.000Z",
            "headerImage": "/assets/blog/1_3eyrU5ECYCprl5r08ilvlg.webp",
            "tags": [
              "pow",
              "chainweb"
            ],
            "author": "Doug Beardsley",
            "authorId": "doug.beardsley",
            "layout": "blog",
            "wordCount": 1371,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/introducing-kadena-account-protocols-kip-0012-2021-09-27",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Introducing Kadena Account Protocols (KIP-0012)",
            "description": "Learn how new account protocols on the Kadena blockchain make multi-chain operation safer and easier! Blockchain custody is hard. At Kadena we set out to solve this hard problem with Pact, by making it easy to do things like key rotation, multi-sig, and autonomous guards, so that the average user can benefit from institutional-level security best practices.",
            "menu": "Introducing Kadena Account Protocols (KIP-0012)",
            "label": "Introducing Kadena Account Protocols (KIP-0012)",
            "publishDate": "2021-09-27T00:00:00.000Z",
            "headerImage": "/assets/blog/1_40Badddk5S15Yw1X3WOSLg.webp",
            "tags": [
              "kda"
            ],
            "author": "Doug Beardsley",
            "authorId": "doug.beardsley",
            "layout": "blog",
            "wordCount": 980,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/introducing-kadenaswap-bountyswap-live-beta-2021-02-02",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Introducing Kadenaswap “Bountyswap” Live Beta",
            "description": "After a successful and productive run in testnet, Kadenaswap is headed to mainnet to start “Bountyswap” — the live beta! It’s a good time to lay out the current plans for Kadenaswap, Bountyswap and the future of multi-protocol, scalable DeFi.",
            "menu": "Introducing Kadenaswap “Bountyswap” Live Beta",
            "label": "Introducing Kadenaswap “Bountyswap” Live Beta",
            "publishDate": "2021-02-02T00:00:00.000Z",
            "headerImage": "/assets/blog/1_KbYZmw4TE6ZQEIszK0gqkA.webp",
            "tags": [
              "chainweb"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 2015,
            "readingTimeInMinutes": 11,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/introducing-the-kadena-live-roadmap-2021-07-30",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Introducing the Kadena Live Roadmap",
            "description": "At Kadena, we’re continually responding to the fast-moving crypto space. Starting as an enterprise blockchain company in 2016, we introduced the world to hybrid blockchain in 2018 before launching the only scalable POW public blockchain in 2020.",
            "menu": "Introducing the Kadena Live Roadmap",
            "label": "Introducing the Kadena Live Roadmap",
            "publishDate": "2021-07-30T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1623,
            "readingTimeInMinutes": 9,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/kadena-ambassador-program-launch-2021-02-23",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Ambassador Program Launch",
            "description": "Kadena is establishing its first-ever Ambassador Program to empower the community to spread awareness and educate a wider audience about the potential of Kadena’s blockchain technology",
            "menu": "Kadena Ambassador Program Launch",
            "label": "Kadena Ambassador Program Launch",
            "publishDate": "2021-02-23T00:00:00.000Z",
            "tags": [
              "ambassador"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1044,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/kadena-dao-meaningful-initiatives-driven-by-the-voice-of-the-community-2021-07-14",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena DAO - Meaningful Initiatives Driven by the Voice of the Community",
            "description": "Kadena has built the framework for the first DAO, Decentralized Autonomous Organization, on its public blockchain called dao.init. As Kadena’s ecosystem continues to grow, the creation of a DAO will allow for the broader community to provide their input in a decentralized manner. The DAO will serve two purposes, 1) allow for the Kadena community to submit and decide on proposals that aim to advance the Kadena ecosystem and 2) establish a decentralized process that can govern the addition of new features to the Kadena platform itself.",
            "menu": "Kadena DAO - Meaningful Initiatives Driven by the Voice of the Community",
            "label": "Kadena DAO - Meaningful Initiatives Driven by the Voice of the Community",
            "publishDate": "2021-07-14T00:00:00.000Z",
            "headerImage": "/assets/blog/1_2K75Ibcik7gE_uvL0JM2eA.webp",
            "tags": [
              "dao"
            ],
            "author": "Will Martino",
            "authorId": "will.martino",
            "layout": "blog",
            "wordCount": 874,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/kadena-roadmap-for-q1-2021-2021-01-14",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Roadmap for Q1 2021",
            "description": "Moving forward in 2021, the team is tracking dramatic shifts in the crypto markets, providing us with helpful data for (re)focusing. We believe that economic infrastructure adds the most value to Kadena at this time. Looking at the year ahead, major initiatives include the full launch of the Kadenaswap DEX alongside decentralized bridges to Ethereum and wrapped KDA. We’ll also continue working towards additional exchange listings and community-led efforts (DAOs).",
            "menu": "Kadena Roadmap for Q1 2021",
            "label": "Kadena Roadmap for Q1 2021",
            "publishDate": "2021-01-14T00:00:00.000Z",
            "headerImage": "/assets/blog/1_NXyEgTYElevRugKNoB7z2A.webp",
            "tags": [
              "kadena",
              "chainweb"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 873,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/kadena-roadmap-for-q2-2021-04-05",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Roadmap for Q2 2021",
            "description": "As we progress through 2021, the Kadena team is all-in to execute major initiatives and amplify brand awareness in the crypto markets. Working closely with our energized and engaged community, we were able to meet every milestone announced in our Q1 Roadmap",
            "menu": "Kadena Roadmap for Q2 2021",
            "label": "Kadena Roadmap for Q2 2021",
            "publishDate": "2021-04-05T00:00:00.000Z",
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 519,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/kadena-telegram-ama-with-stuart-popejoy-2021-03-29",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Telegram AMA with Stuart Popejoy, March 29, 2021 Transcript",
            "description": "A Transcript of the Telegram Ask-Me_Anything with Stuart Popejoy, March 29 2021",
            "menu": "Kadena Telegram AMA, March 29 2021",
            "label": "Kadena Telegram AMA, March 29 2021",
            "publishDate": "2021-03-29T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 1984,
            "readingTimeInMinutes": 10,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/kadena-telegram-ama-with-tehmoonwalker-transcript-2021-05-29",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Telegram AMA with TehMoonWalker, May 27 2021 Transcript",
            "description": "Welcome fellas on this glorious Wednesday evening. Very stoked to have you here with us and really looking forward to all the knowledge you are about to share.",
            "menu": "AMA with TehMoonWalker, May 29 2021 Transcript",
            "label": "AMA with TehMoonWalker, May 29 2021 Transcript",
            "publishDate": "2021-05-29T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 3504,
            "readingTimeInMinutes": 18,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/kadena-telegram-ama-with-the-gem-hunters-2021-05-13",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Telegram AMA with The Gem Hunters, May 13 2021 Transcript",
            "description": "Welcome to the Kadena Live AMA with The Gem Hunters (TGH), we would like to thank the team and community for coming today, and can’t wait to find out more about Kade",
            "menu": "AMA with The Gem Hunters, May 13 2021 Transcript",
            "label": "AMA with The Gem Hunters, May 13 2021 Transcript",
            "publishDate": "2021-05-13T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 3870,
            "readingTimeInMinutes": 20,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/kadena-telegram-ama-with-the-goodfellas-transcript-2021-06-17",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Telegram AMA with The Goodfellas, June 11 2021 Transcript",
            "description": "Welcome To another GoodFellas AMA. Today, we are joined today by the team of Kadena Jeffrey, Francesco, Stuart, and Doug. Can we start with intros? What are your backgrounds/experiences both in the traditional and crypto spaces?",
            "menu": "AMA with The Goodfellas, May 13 2021 Transcript",
            "label": "AMA with The Goodfellas, May 13 2021 Transcript",
            "publishDate": "2021-06-17T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 3137,
            "readingTimeInMinutes": 16,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/kadenas-kda-token-listed-on-kucoin-a-top-ten-exchange-2021-05-10",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena’s KDA Token Listed on Kucoin, a Top Ten Exchange",
            "description": "We are proud to announce that Kadena, the safest and most scalable Proof of Work blockchain, will have its first major listing of 2021 on Kucoin.",
            "menu": "KDA Token Listed on Kucoin",
            "label": "KDA Token Listed on Kucoin",
            "publishDate": "2021-5-10",
            "tags": [
              "kda"
            ],
            "author": "Kadena",
            "authorId": "kadena",
            "layout": "blog",
            "wordCount": 563,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/kadenaswap-update-december-2020-2021-01-01",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadenaswap Update December 2020",
            "description": "Rounding out the year with another quarter of roadmap milestones delivered on time, Kadena has deployed a live version of the Kadenaswap decentralized exchange (DEX) on testnet.",
            "menu": "Kadenaswap Update December 2020",
            "label": "Kadenaswap Update December 2020",
            "publishDate": "2021-01-01T00:00:00.000Z",
            "headerImage": "/assets/blog/1_Wjb7k98TA-dHCeuMnHdz0g.webp",
            "tags": [
              "kadena"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 601,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/mint-a-marketplace-nfts-on-kadena-marmalade-part-1-2021-12-02",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Mint a Marketplace! NFTs on Kadena Marmalade (Part 1)",
            "description": "Learn how new account protocols on the Kadena blockchain make multi-chain operation safer and easier! Blockchain custody is hard. At Kadena we set out to solve this hard problem with Pact, by making it easy to do things like key rotation, multi-sig, and autonomous guards, so that the average user can benefit from institutional-level security best practices.",
            "menu": "Mint a Marketplace! NFTs on Kadena Marmalade (Part 1)",
            "label": "Mint a Marketplace! NFTs on Kadena Marmalade (Part 1)",
            "publishDate": "2021-12-02T00:00:00.000Z",
            "headerImage": "/assets/blog/1_BEuMAVlJ32_pP984cFKAwQ.webp",
            "tags": [
              "marmalade"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 1852,
            "readingTimeInMinutes": 10,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/mint-a-marketplace-nfts-on-kadena-marmalade-part-2-2021-12-03",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Mint a Marketplace NFTs on Kadena Marmalade (Part 2)",
            "description": "In the previous article, we showed how Kadena Marmalade is revolutionizing how NFTs are transacted on-chain with multi-step pacts controlling sale, and token policies offering “pluggable” marketplace implementations for creators to choose from, or write their own! In this article we will go deep into the actual standards and Pact implementations so builders can start minting marketplaces right away on testnet!",
            "menu": "Mint a Marketplace NFTs on Kadena Marmalade (Part 2)",
            "label": "Mint a Marketplace NFTs on Kadena Marmalade (Part 2)",
            "publishDate": "2021-12-03T00:00:00.000Z",
            "headerImage": "/assets/blog/1_BEuMAVlJ32_pP984cFKAwQ.webp",
            "tags": [
              "marmalade"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 1848,
            "readingTimeInMinutes": 10,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/pact-tips-wrapper-contracts-2021-07-04",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact Tips Wrapper Contracts",
            "description": "Smart-contract blockchains are unique app environments as they combine storefronts, back ends, and APIs into one dynamic environment. A single dapp may be composed of numerous contracts an NFT exchange might have separate contracts for handling the auction vs offering a token for instance.",
            "menu": "Pact Tips Wrapper Contracts",
            "label": "Pact Tips Wrapper Contracts",
            "publishDate": "2021-07-04T00:00:00.000Z",
            "headerImage": "/assets/blog/1_ErnEQbK35VB7wxDgqoMy9A.webp",
            "tags": [
              "pact"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 1817,
            "readingTimeInMinutes": 10,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/tokensoft-wrapped-kadenaswap-the-future-of-digital-value-2021-03-04",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Tokensoft Wrapped & Kadenaswap - the Future of Digital Value",
            "description": "Tokensoft Wrapped and Kadena have announced a partnership to bring Wrapped tokens for BTC and ETH to the Kadenaswap DEX in early Q2 2021, following the launch of our live mainnet beta, “Bountyswap”. What does this mean for the road ahead?",
            "menu": "Tokensoft Wrapped & Kadenaswap - the Future of Digital Value",
            "label": "Tokensoft Wrapped & Kadenaswap - the Future of Digital Value",
            "publishDate": "2021-03-04T00:00:00.000Z",
            "headerImage": "/assets/blog/1_eUsRzyRMkkGIFdAg6gBP2A.webp",
            "tags": [
              "pact",
              "kda"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 1249,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2021/update-to-the-kadena-token-economic-model-2021-01-29",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Update to the Kadena Token Economic Model",
            "description": "On January 15 2021, Kadena celebrated its one-year anniversary of the public launch of the Kadena Public blockchain platform, the only sharded, scalable Proof-of-Work smart contract platform that can meet the demand of true industrial-scale operations on a blockchain. It’s a good time to review the token economic model that drives the network, and we’re happy to announce that we’ve revised our platform emissions schedule to address inflation while still enabling us to provide economic infrastructure to drive growth.",
            "menu": "Update to the Kadena Token Economic Model",
            "label": "Update to the Kadena Token Economic Model",
            "publishDate": "2021-01-29T00:00:00.000Z",
            "headerImage": "/assets/blog/1_8VJm1-4VH7yGxvZRSl8zjA.webp",
            "tags": [
              "kda"
            ],
            "author": "Will Martino",
            "authorId": "will.martino",
            "layout": "blog",
            "wordCount": 1718,
            "readingTimeInMinutes": 9,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/blogchain/2021",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "BlogChain 2021",
        "menu": "2021",
        "subTitle": "2021",
        "label": "2021",
        "order": 3,
        "description": "articles..articles...articles 2021",
        "layout": "home",
        "wordCount": 143,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/blogchain/2020/a-first-look-on-integrating-with-rosetta-2020-06-17",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "A First Look on Integrating With Rosetta, Launched by Coinbase",
            "description": "Kadena is a live, full-service smart contract platform and the world’s first scalable, sharded, layer-1 Proof of Work public blockchain. Here at Kadena, we’ve finished the initial cut of our integration with Rosetta, a new open-source technical framework that has just been launched by Coinbase. As one of the first projects to work on Rosetta, we’re taking this opportunity to share what we learned from the experience.",
            "menu": "A First Look on Integrating With Rosetta, Launched by Coinbase",
            "label": "A First Look on Integrating With Rosetta, Launched by Coinbase",
            "publishDate": "2020-06-17T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_b97oiC8M_ePx83B-PW0Cfg.webp",
            "author": "Linda Ortega",
            "authorId": "linda.ortega",
            "layout": "blog",
            "wordCount": 1415,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/announcing-kadena-technical-grants",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Announcing Kadena Technical Grants",
            "description": "Kadena has launched Technical Grants, a structured model designed to reward blockchain developers for contributing their talent to the world’s fastest layer-1 PoW network.",
            "menu": "Announcing Kadena Technical Grants",
            "label": "Announcing Kadena Technical Grants",
            "publishDate": "2020-11-25T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_h-gQ8SjBId21Xhp8IZebMQ.webp",
            "tags": [
              "grant"
            ],
            "author": "Taylor Rolfe",
            "authorId": "taylor.rolfe",
            "layout": "blog",
            "wordCount": 378,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/beginners-guide-to-kadena-accounts-keysets-2020-01-14",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Beginner’s Guide to Kadena Accounts + Keysets",
            "description": "When getting started with the Kadena public blockchain, the first thing you’ll want to do is create an account so you can start transacting with other users. This article will break down exactly what keys are, what an account is, the myriad ways to create one, and how to add your account to several existing tools.",
            "menu": "Beginner’s Guide to Kadena Accounts + Keysets",
            "label": "Beginner’s Guide to Kadena Accounts + Keysets",
            "publishDate": "2020-01-14T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_JfE77s3CWXoDbh4o9F2-gA.webp",
            "tags": [
              "pact"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 2079,
            "readingTimeInMinutes": 11,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/do-anything-on-the-kadena-blockchain-with-a-single-tool-2020-02-21",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Do Anything on the Kadena Blockchain with a Single Tool",
            "description": "Chainweaver is more than a crypto wallet, it is a full blockchain interface providing its users with unmatched control over their network activity.",
            "menu": "Do Anything on the Kadena Blockchain with a Single Tool",
            "label": "Do Anything on the Kadena Blockchain with a Single Tool",
            "publishDate": "2020-02-21T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_DPaqrSYvWQpdKUexyUcgTw.webp",
            "tags": [
              "chainweaver"
            ],
            "author": "Taylor Rolfe",
            "authorId": "taylor.rolfe",
            "layout": "blog",
            "wordCount": 982,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/experience-hybrid-blockchain-2020-05-01",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Experience Hybrid Blockchain",
            "description": "This article summarizes the concept of a hybrid blockchain, describes a simple use case scenario, and then walks through the scenario with a demonstration. Follow along at http://hybrid.chainweb.com/ to experience Kadena’s hybrid blockchain yourself.",
            "menu": "Experience Hybrid Blockchain",
            "label": "Experience Hybrid Blockchain",
            "publishDate": "2020-05-01T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_2BA8I4luclrVgk57_6Nb1Q.webp",
            "tags": [
              "chainweb"
            ],
            "author": "Taylor Rolfe",
            "authorId": "taylor.rolfe",
            "layout": "blog",
            "wordCount": 1215,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/high-gas-prices-peril-or-promise-for-defi-2020-09-02",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "High gas prices peril or promise for DeFi?",
            "description": "On September 1, Ethereum set a new record for high gas prices, with a single DeFi transaction costing over $10 in fees. High fees are the result of congestion, as users pay ever higher fees to ensure their transaction gets into a block. Gas on Ethereum can be seen as “block space rent” and many are saying the rent is too damn high.",
            "menu": "High gas prices peril or promise for DeFi?",
            "label": "High gas prices peril or promise for DeFi?",
            "publishDate": "2020-09-02T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_fynn5el1Ya3Q6F-TbBTFGg.webp",
            "tags": [
              "defi"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 1073,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadena-building-defi-bridge-to-celo-and-joining-alliance-for-prosperity-also-announcing-bounty-2020-12-15",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Building DeFi Bridge to Celo and Joining Alliance for Prosperity, also Announcing Bounty Program for Kadenaswap DEX",
            "description": "Kadena, the first blockchain technology company to come out of J.P. Morgan’s Blockchain Center for Excellence, and Celo, an open platform that makes financial tools accessible to anyone with a mobile phone, are announcing a partnership. As part of the collaboration, Kadena is joining the Alliance for Prosperity. The partnership will see both Celo’s cUSD stablecoin and Kadena’s KDA token interoperate on both platforms via a trustless bridge relay, increasing utilization for both tokens.",
            "menu": "Kadena Building DeFi Bridge to Celo and Joining Alliance for Prosperity, also Announcing Bounty Program for Kadenaswap DEX",
            "label": "Kadena Building DeFi Bridge to Celo and Joining Alliance for Prosperity, also Announcing Bounty Program for Kadenaswap DEX",
            "publishDate": "2020-12-15T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_BWXDWnNDfpa6zTljd7rguQ.webp",
            "tags": [
              "defi",
              "bridge"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 901,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadena-collaborates-with-chainlink-in-industrys-first-hybrid-blockchain-oracle-integration-2020-05-19",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Collaborates with Chainlink in Industry’s First Hybrid Blockchain Oracle Integration",
            "description": "Scalable layer-1 PoW public network, developed by former JP Morgan blockchain team, will deploy Chainlink’s oracles for tamper-proof on-chain data feeds Chainlink and Kadena are working together to integrate Chainlink’s market-leading decentralized oracle network to Kadena’s scalable layer-1 Proof of Work public blockchain. This will be an industry first in deploying oracles to a public/private hybrid blockchain platform.",
            "menu": "Kadena Collaborates with Chainlink in Industry’s First Hybrid Blockchain Oracle Integration",
            "label": "Kadena Collaborates with Chainlink in Industry’s First Hybrid Blockchain Oracle Integration",
            "publishDate": "2020-05-19T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_JGCxne8duh-sQwsqv43p6g.webp",
            "tags": [
              "kadena"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 1342,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadena-completes-hybrid-blockchain-scaling-to-480-000-transactions-per-second-on-20-chains-2020-08-20",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Completes Hybrid Blockchain Scaling to 480,000 Transactions Per Second on 20 Chains",
            "description": "Company concludes monumental upgrade to the world’s first sharded Proof of Work layer-1 blockchain for the scale required of institutional and retail applications NEW YORK — Aug 20, 2020 — Kadena, the first blockchain technology company to come out of J.P. Morgan’s Blockchain Center for Excellence, today announced that its scalable layer-1 public blockchain has increased from 10 to 20 chains, becoming the fastest blockchain platform in the world. Kadena’s Chainweb public protocol functions through a braided, parallelized consensus mechanism, a unique architecture that boosts speeds while preserving the security of the Proof of Work consensus utilized by Bitcoin.",
            "menu": "Kadena Completes Hybrid Blockchain Scaling to 480,000 Transactions Per Second on 20 Chains",
            "label": "Kadena Completes Hybrid Blockchain Scaling to 480,000 Transactions Per Second on 20 Chains",
            "publishDate": "2020-08-20T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_40MoCSBHaDVFNJCgIcrGqQ.webp",
            "tags": [
              "kadena"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 1198,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadena-embraces-defi-with-multi-protocol-decentralized-exchange-kadenaswap-2020-09-29",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Embraces DeFi with Multi-protocol Decentralized Exchange Kadenaswap",
            "description": "Kadena, the first blockchain technology company to come out of J.P. Morgan’s Blockchain Center for Excellence, today announced a multi-protocol decentralized exchange (DEX) named Kadenaswap. Kadenaswap will utilize Kadena’s 20-chain sharded and scalable layer-1 public blockchain with 480,000 transactions per second capability. The company also announced community onboarding initiatives such as partnering with ZelCore on full-node incentivization for miners, offering a free month of gas during October 2020, and launching a developer engagement program.",
            "menu": "Kadena Embraces DeFi with Multi-protocol Decentralized Exchange Kadenaswap",
            "label": "Kadena Embraces DeFi with Multi-protocol Decentralized Exchange Kadenaswap",
            "publishDate": "2020-09-29T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_Q1h18cmTzAA4S4BAk5bXFg.webp",
            "tags": [
              "defi"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 988,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadena-hybrid-blockchain-partners-with-programmable-money-leader-terra-to-expand-defi-ecosystem-2020-11-10",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Hybrid Blockchain Partners with Programmable Money Leader Terra to Expand DeFi Ecosystem",
            "description": "Kadena, the first blockchain technology company to come out of J.P. Morgan’s Blockchain Center for Excellence, and programmable money leader Terra are partnering to contribute their combined expertise towards expanding the DeFi ecosystem. Kadena will add Terra’s Luna stablecoin to the multi-protocol Kadenaswap DEX that will utilize Kadena’s 20-chain sharded and scalable layer-1 public blockchain. This collaboration highlights how Kadena is well positioned to help DeFi scale with high throughput and low gas costs, enabling innovative products like Terra’s Luna stablecoin to accelerate adoption.",
            "menu": "Kadena Hybrid Blockchain Partners with Programmable Money Leader Terra to Expand DeFi Ecosystem",
            "label": "Kadena Hybrid Blockchain Partners with Programmable Money Leader Terra to Expand DeFi Ecosystem",
            "publishDate": "2020-11-10T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1__Usm8O2pFFohsQ6nvuTauA.webp",
            "tags": [
              "defi"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 844,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadena-introduces-chainweaver-to-the-cosmos-ecosystem-2020-01-17",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Introduces Chainweaver to the Cosmos Ecosystem",
            "description": "Kadena, the first blockchain technology company to come out of JP Morgan’s Blockchain Center for Excellence, announced the integration of its digital wallet Chainweaver onto the Cosmos network. Chainweaver is a multi-blockchain interoperable wallet that also functions as a development environment for smart contracts.",
            "menu": "Kadena Introduces Chainweaver to the Cosmos Ecosystem",
            "label": "Kadena Introduces Chainweaver to the Cosmos Ecosystem",
            "publishDate": "2020-01-17T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_TC6Pmg3mMESvs7C1cZFsrA.webp",
            "tags": [
              "chainweaver"
            ],
            "author": "Rebecca Rodriguez",
            "authorId": "rebecca.rodriguez",
            "layout": "blog",
            "wordCount": 755,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadena-launches-public-chain-with-smart-contract-transactions-2020-01-15",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Launches Public Chain with Smart Contract Transactions",
            "description": "Kadena, the first blockchain technology company to come out of JP Morgan’s Blockchain Center for Excellence, has announced the full launch of its public blockchain. Kadena’s public blockchain is first to market as a sharded Proof of Work Layer 1 network. Following the start of genesis mining in October 2019, Kadena has surpassed having two million blocks mined at hash rates as high as 40 TH/s. Today’s launch includes full transactions and the ability to write smart contracts.",
            "menu": "Kadena Launches Public Chain with Smart Contract Transactions",
            "label": "Kadena Launches Public Chain with Smart Contract Transactions",
            "publishDate": "2020-01-15T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_VzDmro2_e8CPGbUG0qyD-w.webp",
            "tags": [
              "smart contract"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 762,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadena-roadmap-for-q1-q2-2020-2020-04-08",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Roadmap for Q1-Q2 2020",
            "description": "Kadena has successfully launched the first sharded layer-1 PoW public blockchain. Since the launch in January, the team has been concentrating on the growth and stability of the public network. At the end of March, the Kadena public blockchain grew to a hash rate above 100 Terahashes per second (that’s 100 trillion hashes), completed over 75,000 successful token transfers, and mined more than 4 million blocks.",
            "menu": "Kadena Roadmap for Q1-Q2 2020",
            "label": "Kadena Roadmap for Q1-Q2 2020",
            "publishDate": "2020-04-08T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_4DCX4tcoFGCSYqE4K_wy5Q.webp",
            "tags": [
              "kadena"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 496,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadena-roadmap-for-q3-2020-2020-07-29",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Roadmap for Q3 2020",
            "description": "Kadena has successfully launched the first sharded layer-1 PoW public blockchain. Since the launch in January, the team has been concentrating on the growth and stability of the public network. At the end of March, the Kadena public blockchain grew to a hash rate above 100 Terahashes per second (that’s 100 trillion hashes), completed over 75,000 successful token transfers, and mined more than 4 million blocks.",
            "menu": "Kadena Roadmap for Q3 2020",
            "label": "Kadena Roadmap for Q3 2020",
            "publishDate": "2020-07-29T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_NQHVZvgxYDdMjrIgC80PXg.webp",
            "tags": [
              "pact"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 550,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadena-roadmap-for-q4-2020-2020-10-28",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Roadmap for Q4 2020",
            "description": "As announced last month, creating the multi-protocol Kadenaswap DEX is the primary focus for Kadena’s blockchain engineers for the rest of the year and going forward through 2021. Of course, the team will also be working on additional efforts to benefit the ecosystem and community. Some of the activities we’ve already completed in October include Co-founder and CEO Will Martino speaking at LA Blockchain Summit and the Zel project partnering with us for node incentivization on the Flux platform.",
            "menu": "Kadena Roadmap for Q4 2020",
            "label": "Kadena Roadmap for Q4 2020",
            "publishDate": "2020-10-28T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_LQouI-FC-8Pmkxs2-5UG7w.webp",
            "tags": [
              "kadena"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 551,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/kadenas-kda-token-has-first-listing-on-bittrex-global-a-top-ten-exchange-2020-06-25",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena’s KDA Token Has First Listing on Bittrex Global, a Top Ten Exchange",
            "description": "The company is also open-sourcing a COVID-19 test result tracking dApp and announcing the public blockchain shard count is scaling from 10 to 20 chains BROOKLYN, N.Y., June 25, 2020 — Kadena, the first blockchain technology company to come out of JP Morgan’s Blockchain Center for Excellence, will have the first official listing of its KDA token on Bittrex Global. Bittrex Global is a Top Ten exchange as measured by real trade volume according to Bitwise Investments and Messari. The company is also open-sourcing a coronavirus test result tracking application made available for the healthcare industry effective immediately. Additionally, Kadena continues to lead the industry by announcing that its public network is scaling from 10 to 20 chains on July 31.",
            "menu": "Kadena’s KDA Token Has First Listing on Bittrex Global, a Top Ten Exchange",
            "label": "Kadena’s KDA Token Has First Listing on Bittrex Global, a Top Ten Exchange",
            "publishDate": "2020-06-25T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_HJDBr9jX5Ajucwmynt15eg.webp",
            "tags": [
              "kda"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 1456,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/polkadot-collaboration-update-researching-pact-core-for-wasm-and-exploring-kadenadot-2020-08-12",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Polkadot Collaboration Update Researching Pact Core for WASM and Exploring KadenaDOT",
            "description": "As part of our ongoing work with the Polkadot team, our lead language engineer Emily Pillmore developed an exciting long-term approach to extend the benefits of Pact to the Polkadot community while also furthering Pact as the standard for smart contracts Pact Core. With Pact Core, Polkadot or any WASM-compatible platform can natively execute Pact smart contract code with the help of a minimal interpreter installed directly on-chain.",
            "menu": "Polkadot Collaboration Update Researching Pact Core for WASM and Exploring KadenaDOT",
            "label": "Polkadot Collaboration Update Researching Pact Core for WASM and Exploring KadenaDOT",
            "publishDate": "2020-08-12T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_gx_qreTbIj3PIoY0_4KtRw.webp",
            "tags": [
              "pact"
            ],
            "author": "Will Martino",
            "authorId": "will.martino",
            "layout": "blog",
            "wordCount": 645,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2020/the-first-crypto-gas-station-is-now-on-kadenas-blockchain-2020-08-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The First Crypto Gas Station is Now on Kadena’s Blockchain",
            "description": "Here at Kadena, we’re focused on making blockchain as useful and usable as possible. From our user-friendly and powerful smart contract language Pact, to our wallet and developer environment Chainweaver, we’re creating products that make the safety and global reach of blockchain accessible to everyone. Today, we’re announcing that we’ve implemented the world’s first autonomous crypto gas station on a public blockchain.",
            "menu": "The First Crypto Gas Station is Now on Kadena’s Blockchain",
            "label": "The First Crypto Gas Station is Now on Kadena’s Blockchain",
            "publishDate": "2020-08-06T00:00:00.000Z",
            "headerImage": "/assets/blog/2020/1_yl4w71ccQB02X08t389QDg.webp",
            "tags": [
              "gas station",
              "pact"
            ],
            "author": "Taylor Rolfe",
            "authorId": "taylor.rolfe",
            "layout": "blog",
            "wordCount": 1624,
            "readingTimeInMinutes": 9,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/blogchain/2020",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "BlogChain 2020",
        "menu": "2020",
        "subTitle": "2020",
        "label": "2020",
        "order": 3,
        "description": "articles..articles...articles 2020",
        "layout": "home",
        "wordCount": 143,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/blogchain/2019/all-about-chainweb-101-and-faqs-2019-02-01",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena’s Public Blockchain 101 and FAQs",
            "description": "Learn more about Kadena’s public, proof-of-work blockchain protocol designed for scalability and security.",
            "menu": "Kadena’s Public Blockchain 101 and FAQs",
            "label": "Kadena’s Public Blockchain 101 and FAQs",
            "publishDate": "2019-02-01T00:00:00.000Z",
            "headerImage": "/assets/blog/1_7spjR-a_pYCJmQLt2qEamg.webp",
            "tags": [
              "kadena",
              "pow"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 1417,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/announcement-kadena-public-blockchain-testnet-live-2019-03-26",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Announcement Kadena Public Blockchain Testnet LIVE",
            "description": "Kadena is excited to announce that Chainweb–Kadena’s public proof-of-work blockchain–is now LIVE in testnet!",
            "menu": "Announcement Kadena Public Blockchain Testnet LIVE",
            "label": "Announcement Kadena Public Blockchain Testnet LIVE",
            "publishDate": "2019-03-26T00:00:00.000Z",
            "headerImage": "/assets/blog/1_G4ggggsptLXt7z0Rry7UJA.webp",
            "tags": [
              "kadena",
              "chainweb",
              "pact"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 561,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/announcing-pact-3-0-2019-06-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Announcing Pact 3.0",
            "description": "At Kadena, smart contract technology is something we’re very passionate about — so we’re excited to announce the release of Pact 3.0. It’s our biggest Pact release in over a year and delivers significant new features designed to make Pact the premier standard for smart contract authoring in both public and private blockchains.",
            "menu": "Announcing Pact 3.0",
            "label": "Announcing Pact 3.0",
            "publishDate": "2019-06-06T00:00:00.000Z",
            "headerImage": "/assets/blog/1_jD9StZRQL8Gxw-J4z1Lc9Q.webp",
            "tags": [
              "pact"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 1598,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/blockchain-is-finally-becoming-the-next-gen-database-of-choice-2019-07-30",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Blockchain is finally becoming the next-gen database of choice",
            "description": "Kadena Founder & CEO Will Martino explains to VentureBeat how blockchain solves problems traditional databases can’t handle.",
            "menu": "Blockchain is finally becoming the next-gen database of choice",
            "label": "Blockchain is finally becoming the next-gen database of choice",
            "publishDate": "2019-07-30T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 616,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/blockchain-summer-the-road-to-mainstream-adoption-2019-07-29",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Blockchain summer - the road to mainstream adoption",
            "description": "The Kadena Team is excited to present Blockchain Summer! Please join us as we host a live panel on The Road to Mainstream Adoption with guests such as Elizabeth Polanco formerly of J.P. Morgan, Arianna Simpson from ASP, Tarun Chitra from Gauntlet Networks, and our very own Founder and CEO, Will Martino. Journalist Jon Victor from The Information will moderate the panel.",
            "menu": "Blockchain summer",
            "label": "Blockchain summer",
            "publishDate": "2019-07-29T00:00:00.000Z",
            "headerImage": "/assets/blog/kl314KSDD7wK0hd2pbA.webp",
            "tags": [
              "kadena"
            ],
            "author": "Miguel Angel Romero Jr.",
            "authorId": "miguel.angel",
            "layout": "blog",
            "wordCount": 615,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/conference-community-events-schedule-2019-01-18",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Conference & Community Events Schedule",
            "description": "Check Kadena out at the following events as we strengthen our platform, continue to push the limits of blockchain innovation, and drive even more adoption.",
            "menu": "Kadena Conference & Community Events Schedule",
            "label": "Kadena Conference & Community Events Schedule",
            "publishDate": "2019-01-18T00:00:00.000Z",
            "headerImage": "/assets/blog/1_e-sOQIuA2mE-9eft3OQXOQ.webp",
            "tags": [
              "kadena"
            ],
            "author": "Miguel Angel Romero Jr.",
            "authorId": "miguel.angel",
            "layout": "blog",
            "wordCount": 858,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/faq-for-kadenas-public-blockchain-2019-12-02",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "FAQ for Kadena’s Public Blockchain",
            "description": "Kadena has released mainnet mining to the public, inviting the mining community to begin solving blocks on the Kadena public blockchain. Kadena’s network has come alive with activity as miners from all over the world participate on the Kadena network.",
            "menu": "FAQ for Kadena’s Public Blockchain",
            "label": "FAQ for Kadena’s Public Blockchain",
            "publishDate": "2019-12-02T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_ssB8LvGuMvA270XnoZWHBQ.webp",
            "tags": [
              "kadena"
            ],
            "author": "Rebecca Rodriguez",
            "authorId": "rebecca.rodriguez",
            "layout": "blog",
            "wordCount": 865,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/gauntlet-study-finds-kadena-public-blockchain-is-secure-and-scalable-2019-09-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Gauntlet Study Finds Kadena Public Blockchain is Secure and Scalable",
            "description": "Learn more about the findings from the IEEE peer-reviewed research paper",
            "menu": "Gauntlet Study Finds Kadena Public Blockchain is Secure and Scalable",
            "label": "Gauntlet Study Finds Kadena Public Blockchain is Secure and Scalable",
            "publishDate": "2019-09-06T00:00:00.000Z",
            "headerImage": "/assets/blog/1_D0s4fdv1ko4Cx_DAmima_Q.webp",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 612,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/hybrid-blockchain-101-2019-10-23",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Hybrid Blockchain 101",
            "description": "What a public-private hybrid blockchain makes possible.",
            "menu": "Hybrid Blockchain 101",
            "label": "Hybrid Blockchain 101",
            "publishDate": "2019-10-23T00:00:00.000Z",
            "headerImage": "/assets/blog/1_cXMen2j6k5hcvXVgyEqqzw.webp",
            "tags": [
              "kadena"
            ],
            "author": "Miguel Angel Romero Jr.",
            "authorId": "miguel.angel",
            "layout": "blog",
            "wordCount": 1339,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/introducing-kadenamint-and-chainweb-testnet-v2-2019-08-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Introducing Kadenamint and Public Blockchain Testnet v2",
            "description": "Kadena receives grant to deploy Pact smart contract language to Cosmos ecosystem, updates testnet (v2) with a public binary and dashboard.",
            "menu": "Introducing Kadenamint and Public Blockchain Testnet v2",
            "label": "Introducing Kadenamint and Public Blockchain Testnet v2",
            "publishDate": "2019-08-06T00:00:00.000Z",
            "headerImage": "/assets/docs/1_ioGNdm7WNixtlNPLKwo9eQ.webp",
            "tags": [
              "kadena"
            ],
            "author": "Doug Beardsley",
            "authorId": "doug.beardsley",
            "layout": "blog",
            "wordCount": 751,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/introducing-kips-kadena-improvement-proposals-2019-08-14",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Introducing KIPs - Kadena Improvement Proposals",
            "description": "Similar to other improvement proposals that you may be familiar with from Bitcoin and Ethereum, Kadena Improvement Proposals (KIPs) allow participants to introduce new changes to the blockchain in a transparent manner.",
            "menu": "Introducing KIPs",
            "label": "Introducing KIPs",
            "publishDate": "2019-08-14T00:00:00.000Z",
            "headerImage": "/assets/blog/1_CkkM7zCahsGSNluuOQ0w3w.webp",
            "tags": [
              "kadena"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 835,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-1-1-release-schedule-chainweb-transfers-roadmap-2019-11-25",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena 1.1 Release Schedule/Chainweb Transfers Roadmap",
            "description": "As part of our ongoing efforts to keep the community informed, we are sharing the release schedule for Kadena 1.1, which enables coin transfers on the Kadena public blockchain. After the initial release, the transition from version 1.0.5 to 1.1 will take place over three stages from December 2 to December 6, 2019, followed by a ramp-up period of transfer volume.",
            "menu": "Kadena 1.1 Release Schedule/Chainweb Transfers Roadmap",
            "label": "Kadena 1.1 Release Schedule/Chainweb Transfers Roadmap",
            "publishDate": "2019-11-25T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_kpy5UKorBY2Kp6bf8MYL4g.webp",
            "tags": [
              "chainweb"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 594,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-ama-with-kyle-samani-209-03-14",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena AMA with Kyle Samani",
            "description": "Debate Proof of Work or Proof of Stake? Join Multicoin Capital Managing Partner Kyle Samani and Kadena CEO Will Martino on March 20th at 2:00PM ET for a LIVE Discord AMA on Proof of Work vs. Proof of Stake — New Findings, Perspectives and Tradeoffs.",
            "menu": "Kadena AMA with Kyle Samani",
            "label": "Kadena AMA with Kyle Samani",
            "publishDate": "2019-03-14T00:00:00.000Z",
            "tags": [
              "pow"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 327,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-ama-with-ronghui-gu-2019-04-17",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena AMA with Certik Co-founder Ronghui Gu",
            "description": "We invite you to join Stuart Popejoy, President of Kadena & Professor Ronghui Gu Co-founder of Certik for a live Discord AMA on May 7th at 3 pm ET / 12 pm PT on Formal Verification and covering broad uses and applicability in blockchain.",
            "menu": "Kadena AMA with Certik Co-founder Ronghui Gu",
            "label": "Kadena AMA with Certik Co-founder Ronghui Gu",
            "publishDate": "2019-04-17T00:00:00.000Z",
            "headerImage": "/assets/blog/1_I827oIhMvsisbOvfMiO2Rw.webp",
            "tags": [
              "chainweb"
            ],
            "author": "Miguel Angel Romero Jr.",
            "authorId": "miguel.angel",
            "layout": "blog",
            "wordCount": 445,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-and-rymedi-validate-quality-of-medicinal-products-on-blockchain-2019-12-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena and Rymedi Validate Quality of Medicinal Products on Blockchain",
            "description": "Kadena, the first blockchain technology company to come out of JP Morgan’s Blockchain Center for Excellence, announced a strategic partnership with Rymedi, providers of a data platform revolutionizing healthcare supply chains. Rymedi’s integration with Kadena’s blockchain provides immutable supply genealogy and multi-partner data access, extending existing client capabilities, ranging from tracking pharmaceutical supply chain in developing countries such as Mongolia and Kenya to assisting hemp/CBD growers and extractors looking to bring the safest products to market.",
            "menu": "Kadena and Rymedi Validate Quality of Medicinal Products on Blockchain",
            "label": "Kadena and Rymedi Validate Quality of Medicinal Products on Blockchain",
            "publishDate": "2019-12-06T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_8dws7pDUv76OAVl5jkxWsQ.webp",
            "tags": [
              "kadena"
            ],
            "author": "Rebecca Rodriguez",
            "authorId": "rebecca.rodriguez",
            "layout": "blog",
            "wordCount": 459,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-announces-chainweb-blockchain-mainnet-launch-date-testnet-miner-whitelist-2019-05-13",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Announces Public Blockchain Mainnet Launch Date & Testnet Miner Whitelist",
            "description": "The Kadena team is excited to announce that our scalable Proof of Work public blockchain will be launching mainnet on October 30, 2019! We also have updates from our testnet, including an upcoming whitelist queue for miners to participate in our testnet.",
            "menu": "Kadena Announces Public Blockchain Mainnet Launch Date & Testnet Miner Whitelist",
            "label": "Kadena Announces Public Blockchain Mainnet Launch Date & Testnet Miner Whitelist",
            "publishDate": "2019-05-13T00:00:00.000Z",
            "headerImage": "/assets/blog/1_xxQ-iEPWZDrWwSpvKpOm2w.webp",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 412,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-at-consensus-2019-2019-05-01",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena at Consensus 2019",
            "description": "This year we’re going out of our way to connect with the community beyond the conference space. Below is the complete list of events where we will appear during the week, listed in chronological order. Come out and meet the Kadena Team!",
            "menu": "Kadena at Consensus 2019",
            "label": "Kadena at Consensus 2019",
            "publishDate": "2019-05-01T00:00:00.000Z",
            "headerImage": "/assets/blog/1_r_A9MY_7i_J8cFdgZAMUMg.webp",
            "tags": [
              "kadena"
            ],
            "author": "Miguel Angel Romero Jr.",
            "authorId": "miguel.angel",
            "layout": "blog",
            "wordCount": 862,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-blockchain-summer-highlights-2019-08-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Presents “Blockchain Summer - The Road to Mainstream Adoption”",
            "description": "We were pleased to host our fellow NYC blockchain community members on Wednesday, July 31 at our Brooklyn headquarters for a night of blockchain, banter, and barbecue.",
            "menu": "Kadena Presents Blockchain Summer",
            "label": "Kadena Presents Blockchain Summer",
            "publishDate": "2019-08-06T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 441,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-bloomberg-tv-monica-quaintance-future-of-blockchain-2019-06-17",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena on Bloomberg TV Monica Quaintance shares expert opinion on the future of blockchain",
            "description": "At Kadena, smart contract technology is something we’re very passionate about — so we’re excited to announce the release of Pact 3.0. It’s our biggest Pact release in over a year and delivers significant new features designed to make Pact the premier standard for smart contract authoring in both public and private blockchains.",
            "menu": "Kadena on Bloomberg TV",
            "label": "Kadena on Bloomberg TV",
            "publishDate": "2019-06-17T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 550,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-engineering-updates-jan-2019-2019-02-05",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Engineering Updates Feb 2019",
            "description": "A recap of recent features and upcoming milestones on our technical roadmap.",
            "menu": "Kadena Engineering Updates Feb 2019",
            "label": "Kadena Engineering Updates Feb 2019",
            "publishDate": "2019-02-05T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 308,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-launches-blockchain-as-a-service-baas-on-azure-marketplace-2019-08-27",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Launches Blockchain-as-a-Service (BaaS) on Azure Marketplace",
            "description": "Learn more about our easy provisioning and formally verified smart contracts on Microsoft’s cloud platform.",
            "menu": "Kadena Launches Blockchain-as-a-Service",
            "label": "Kadena Launches Blockchain-as-a-Service",
            "publishDate": "2019-08-27T00:00:00.000Z",
            "headerImage": "/assets/blog/0_QgOv9OHFdAY2-9Mk.png",
            "tags": [
              "kadena"
            ],
            "author": "Ben Jessel",
            "authorId": "ben.jessel",
            "layout": "blog",
            "wordCount": 763,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-new-look-same-mission-2019-03-19",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena New Look, Same Mission",
            "description": "A review of our rebranded look. You might have noticed a change in our look, feel, and logo recently across a few of our social media platforms and website. Kadena has grown a lot across a number of fronts as a team (from four to twenty-four full employees in the last year!), as a community (we held meetups in Asia and across North America, and partnered with Alteum in Latin America), and as a holistic blockchain platform, from a purely enterprise blockchain reflecting our JP Morgan roots, to a hybrid blockchain platform with an integrated, open-source smart contract language.",
            "menu": "Kadena New Look, Same Mission",
            "label": "Kadena New Look, Same Mission",
            "publishDate": "2019-03-19T00:00:00.000Z",
            "headerImage": "/assets/blog/1_sv7Bttb-Wg98ZiJm6gC1rg.webp",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 671,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-private-blockchain-launches-on-amazon-aws-marketplace-2019-01-23",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Private Blockchain Launches on Amazon (AWS) Marketplace",
            "description": "Scalable enterprise smart-contract solution now available to AWS users for free. While Kadena is currently making waves in public blockchain and safer smart contracts, raising $12M last year and bringing one of the forefathers of cryptography to our advising team — our first and founding invention was a truly scalable, truly distributed ledger known as ScalableBFT, dubbed by CoinDesk as “The First Real Private Blockchain.”",
            "menu": "Kadena Private Blockchain Launches on Amazon (AWS) Marketplace",
            "label": "Kadena Private Blockchain Launches on Amazon (AWS) Marketplace",
            "publishDate": "2019-01-23T00:00:00.000Z",
            "headerImage": "/assets/blog/1_9Fg_T12VyTTNcIUmqYce_g.webp",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 890,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-public-blockchain-getting-started-with-transfers-2019-12-19",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Public Blockchain. Getting Started with Transfers",
            "description": "Kadena began enabling Kadena (KDA) token transfers on December 17. The network has experienced some serious growth as we’ve transitioned from testnet to mainnet, with over 1,000,000 blocks mined by more than 10,000 GPUs (at an average hash rate between 10–15 TH/second) on mainnet. We’ve been heavily relying on the community to help establish best miner practices in the network.",
            "menu": "Kadena Public Blockchain. Getting Started with Transfers",
            "label": "Kadena Public Blockchain. Getting Started with Transfers",
            "publishDate": "2019-12-19T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/0_N20Oo9xivfuJFuug.webp",
            "tags": [
              "pact"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 4510,
            "readingTimeInMinutes": 23,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-public-blockchain-releases-fully-public-testnet-v3-hashing-algorithm-and-mining-api-2019-09-18",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Public Blockchain Releases Fully Public Testnet (v3), Hashing Algorithm, and Mining API",
            "description": "September 18, 2019 — Kadena’s public blockchain testnet is now fully open to the public! The latest version of our testnet (v3) includes important updates for miners and interested participants, including the announcement of our mainnet hash function (Blake2s) and the release of our Mining Client. In this post, we’ll explain what these new testnet features mean for the community.",
            "menu": "Fully Public Testnet (v3), Hashing Algorithm, and Mining API",
            "label": "Fully Public Testnet (v3), Hashing Algorithm, and Mining API",
            "publishDate": "2019-09-18T00:00:00.000Z",
            "headerImage": "/assets/blog/1_j-19orafTNN7mVB6M4V3Qg.webp",
            "author": "Miguel Angel Romero Jr.",
            "authorId": "miguel.angel",
            "layout": "blog",
            "wordCount": 550,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-releases-mainnet-mining-and-announces-token-sale-2019-11-04",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Releases Mainnet Mining and Announces Token Sale",
            "description": "Kadena’s mainnet is now fully accessible for public mining. The release provides miners with the opportunity to solve blocks on Kadena’s public blockchain. People can also watch the mining of the parallel chains through Kadena’s Block Explorer, a tool that allows for tracking in real-time.",
            "menu": "Kadena Releases Mainnet Mining and Announces Token Sale",
            "label": "Kadena Releases Mainnet Mining and Announces Token Sale",
            "publishDate": "2019-11-04T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_0xKrN3s6yzLmc23Kj7IzxA.webp",
            "author": "Rebecca Rodriguez",
            "authorId": "rebecca.rodriguez",
            "layout": "blog",
            "wordCount": 2293,
            "readingTimeInMinutes": 12,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-to-explore-implementation-of-pact-for-polkadot-ecosystem-2019-11-12",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena to Explore Implementation of Pact for Polkadot Ecosystem",
            "description": "Kadena, the first blockchain technology company to come out of JP Morgan’s Blockchain Center for Excellence, has signed an agreement with Web3 Foundation to explore the implementation of Pact on Polkadot.",
            "menu": "Kadena to Explore Implementation of Pact for Polkadot Ecosystem",
            "label": "Kadena to Explore Implementation of Pact for Polkadot Ecosystem",
            "publishDate": "2019-11-12T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_GTgK9aN3QCghHn7Zd9GeoQ.webp",
            "tags": [
              "pact"
            ],
            "author": "Rebecca Rodriguez",
            "authorId": "rebecca.rodriguez",
            "layout": "blog",
            "wordCount": 547,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadena-token-transfers-go-live-2019-12-17",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Token Transfers Go Live",
            "description": "Today, Kadena has begun enabling Kadena (KDA) token transfers. Since we announced mining to our community on October 30, the network has experienced significant growth. As of December 17, we have seen over 1,000,000 blocks mined by more than 10,000 GPUs (at an average hash rate between 10–15 TH/second). Now, tokens earned by miners are transferable from and to other people (peer-to-peer). Token transfers represent the second stage towards the full launch of Kadena’s hybrid blockchain platform and Pact smart contract transactions early next year.",
            "menu": "Kadena Token Transfers Go Live",
            "label": "Kadena Token Transfers Go Live",
            "publishDate": "2019-12-17T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_Cxpn_A_lQAYXzrV1hHZkCg.webp",
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 561,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadenas-roadmap-to-a-hybrid-blockchain-platform-2019-03-14",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena’s Roadmap to a Hybrid Blockchain Platform",
            "description": "Learnings as we look ahead in 2019. When Kadena was founded in June 2016 by Will Martino and Stuart Popejoy, the mission was ambitious and clear build a secure and scalable blockchain to execute mission-critical business workflows that meet the needs of large enterprises. As part of the leadership working on Juno at JP Morgan’s blockchain technology group, Stuart and Will knew that scalability and smart contract safety must be considered in the earliest stages of a platform’s design.",
            "menu": "Kadena’s Roadmap to a Hybrid Blockchain Platform",
            "label": "Kadena’s Roadmap to a Hybrid Blockchain Platform",
            "publishDate": "2019-03-14T00:00:00.000Z",
            "headerImage": "/assets/blog/1_Z8h2VlFBFLCxN62TkY6wrQ.webp",
            "tags": [
              "pact"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 1346,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/kadenas-stuart-popejoy-and-will-martino-speak-at-world-blockchain-forum-2019-10-11",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena’s Stuart Popejoy and Will Martino Speak at World Blockchain Forum",
            "description": "Highlights from World Blockchain Forum on blockchain application in financial services",
            "menu": "Kadena’s Stuart Popejoy and Will Martino Speak at World Blockchain Forum",
            "label": "Kadena’s Stuart Popejoy and Will Martino Speak at World Blockchain Forum",
            "publishDate": "2019-10-11T00:00:00.000Z",
            "headerImage": "/assets/blog/0_LBqMHBRpVAueiHqI.jpg",
            "author": "Rebecca Rodriguez",
            "authorId": "rebecca.rodriguez",
            "layout": "blog",
            "wordCount": 380,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/meet-the-kadena-team-founder-ceo-will-martino-2019-10-31",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Meet The Kadena Team - Founder & CEO, Will Martino",
            "description": "Learn about his love for audiobooks, the amazing team he has assembled, and the “dark side” of blockchain.",
            "menu": "Meet The Kadena Team - Founder & CEO, Will Martino",
            "label": "Meet The Kadena Team - Founder & CEO, Will Martino",
            "publishDate": "2019-10-31T00:00:00.000Z",
            "headerImage": "/assets/blog/1_XhGJM7IRmpSerlCjrnIKoQ.webp",
            "author": "Miguel Angel Romero Jr.",
            "authorId": "miguel.angel",
            "layout": "blog",
            "wordCount": 1046,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/meet-the-kadena-team-founder-president-stuart-popejoy-2019-10-17",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Meet The Kadena Team - Founder & President, Stuart Popejoy",
            "description": "Learn about his love for Algorithmic Music Compositions, why we’re still in the dark age of software development, and where blockchain will be in 10–20 years.",
            "menu": "Meet The Kadena Team - Founder & President, Stuart Popejoy",
            "label": "Meet The Kadena Team - Founder & President, Stuart Popejoy",
            "publishDate": "2019-10-17T00:00:00.000Z",
            "headerImage": "/assets/blog/1_cOLN33RfWbp9ukaBegGcpA.webp",
            "author": "Miguel Angel Romero Jr.",
            "authorId": "miguel.angel",
            "layout": "blog",
            "wordCount": 840,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/nyc-crypto-blockchain-events-2019-03-01",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "NYC Crypto blockchain events",
            "description": "NYC Crypto blockchain events",
            "menu": "NYC Crypto blockchain events",
            "label": "NYC Crypto blockchain events",
            "publishDate": "2019-03-01T00:00:00.000Z",
            "headerImage": "/assets/blog/1_Y4t6fTY50F49I4Bm-4SomA.webp",
            "author": "Leah Bingham",
            "authorId": "leah.bingham",
            "layout": "blog",
            "wordCount": 648,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/pact-3-1-is-unleashed-2019-08-22",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact 3.1 is Unleashed!",
            "description": "After a lot of hard work by the team at Kadena, we are pleased to announce the release of Pact 3.1! This new version of Pact brings significant additions to the language, including expanded Formal Verification coverage for our interfaces and governance, and our new cross-chain features in defpact, which makes it dead simple to write cross-chain multi-step transactions.",
            "menu": "Pact 3.1 is Unleashed!",
            "label": "Pact 3.1 is Unleashed!",
            "publishDate": "2019-08-22T00:00:00.000Z",
            "headerImage": "/assets/blog/1_Pcj9Zf_irC35TwEGJlpz1Q.webp",
            "tags": [
              "pact",
              "formal verification"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 1090,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/pact-solving-smart-contract-governance-and-upgradeability-2019-04-05",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact - Solving Smart Contract Governance and Upgradeability",
            "description": "The blockchain industry undeniably spends a great deal of energy discussing governance, but sometimes the focus of governance gets confused. Usually, the focus is on the blockchain protocol layer, arguing about hard forks and the like. However, a major underexplored topic to consider is governance at the smart contract layer, especially since, for Ethereum at least, certain hard forks were motivated by bugs and exploits in smart contracts, not the protocol itself.",
            "menu": "Pact - Solving Smart Contract Governance and Upgradeability",
            "label": "Pact - Solving Smart Contract Governance and Upgradeability",
            "publishDate": "2019-04-05T00:00:00.000Z",
            "headerImage": "/assets/blog/1_NOwRG03NfMqyaqGrmdPfKg.webp",
            "tags": [
              "pact"
            ],
            "author": "Marie Leaf",
            "authorId": "marie.leaf",
            "layout": "blog",
            "wordCount": 1340,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/roadmap-for-kadenas-hybrid-blockchain-launch-in-january-2020-2019-12-04",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Roadmap for Kadena’s Hybrid Blockchain Launch in January 2020",
            "description": "As Kadena continues working toward the full launch of our hybrid blockchain platform in January 2020, we’d like to share the progress we’ve made so far. In addition to reaching the business and technology milestones following our last roadmap update, we have appreciation for the industry-leading conferences and partners that have collaborated with us because they see the value in Kadena’s hybrid network. Utilizing Kadena’s open-sourced Pact smart contract language (with Formal Verification), our platform will deliver simple and secure interoperability between both public and permissioned chains.",
            "menu": "Roadmap for Kadena’s Hybrid Blockchain Launch in January 2020",
            "label": "Roadmap for Kadena’s Hybrid Blockchain Launch in January 2020",
            "publishDate": "2019-12-04T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_5QtIuWilmEdMKrygNeF79Q.webp",
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 1215,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/safer-smarter-contracts-with-pact-2019-02-20",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Safer, Smarter Contracts with Pact",
            "description": "Smart contracts are the key to realizing the full potential of blockchain technology; a smart contract may one day secure your house on a blockchain, assure your digital identity, enable easy international payments, and much more.",
            "menu": "Safer, Smarter Contracts with Pact",
            "label": "Safer, Smarter Contracts with Pact",
            "publishDate": "2019-02-20T00:00:00.000Z",
            "headerImage": "/assets/blog/1_F3EjRcDtfBjShCP0qszVLg.webp",
            "tags": [
              "pact",
              "smart contract",
              "formal verification"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 1683,
            "readingTimeInMinutes": 9,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/scalablebft-kadenas-private-blockchain-101-2019-03-09",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena’s Private Blockchain 101",
            "description": "Evaluating how our private blockchain solution sets us apart from the competition",
            "menu": "Kadena’s Private Blockchain 101",
            "label": "Kadena’s Private Blockchain 101",
            "publishDate": "2019-03-09T00:00:00.000Z",
            "headerImage": "/assets/blog/1_D5NZGx0CsixlX0CnLgCRLA.wepb",
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 977,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/the-complete-crypto-wallet-user-guide-2019-11-20",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The Complete Crypto Wallet User Guide",
            "description": "In the field of blockchain, one of the first experiences that users typically have is with a “crypto wallet.” While cryptocurrency is one of many use cases for blockchain, it is the most popular and interesting for new participants. Even in the early days of this technology, there is already an overwhelmingly broad variety of crypto wallet providers. Their fea",
            "menu": "The Complete Crypto Wallet User Guide",
            "label": "The Complete Crypto Wallet User Guide",
            "publishDate": "2019-11-20T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_byNwUdcRqQV2pExRsgK5KA.webp",
            "tags": [
              "smart wallet"
            ],
            "author": "Taylor Rolfe",
            "authorId": "taylor.rolfe",
            "layout": "blog",
            "wordCount": 5078,
            "readingTimeInMinutes": 26,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/the-future-of-blockchain-is-both-public-and-private-2019-11-18",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The Future of Blockchain Is Both Public and Private",
            "description": "It’s 2019, and with Facebook’s announcement of Libra and J.P. Morgan’s introduction of JPM Coin, it has become clear that the future of business involves blockchain technology. What this means in practice, however, is harder to pinpoint. There is currently a philosophical divide when it comes to blockchain. The enterprise mindset, as represented by JP Morgan, IBM and the like, sees blockchain as only being useful if the participants are tightly controlled. This is what we call a “private” or “permissioned” blockchain.",
            "menu": "The Future of Blockchain Is Both Public and Private",
            "label": "The Future of Blockchain Is Both Public and Private",
            "publishDate": "2019-11-18T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_JLawwD1nZ9HTXmK8l6TVaA.webp",
            "tags": [
              "smart wallet"
            ],
            "author": "Anagha Mercado",
            "authorId": "anagha.mercado",
            "layout": "blog",
            "wordCount": 1140,
            "readingTimeInMinutes": 6,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/the-kadena-token-economic-model-2019-10-30",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The Kadena Token Economic Model",
            "description": "Learn more about our easy provisioning and formally verified smart contracts on Microsoft’s cloud platform.",
            "menu": "The Kadena Token Economic Model",
            "label": "The Kadena Token Economic Model",
            "publishDate": "2019-10-30T00:00:00.000Z",
            "tags": [
              "kda"
            ],
            "author": "Will Martino",
            "authorId": "will.martino",
            "layout": "blog",
            "wordCount": 2794,
            "readingTimeInMinutes": 14,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/turing-completeness-and-smart-contract-security-2019-02-11",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Turing Completeness and Smart Contract Security",
            "description": "At Kadena, we talk a lot about blockchain design decisions. One particularly profound design decision that I’ve come across recently revolves around the property of Turing completeness, which sparked debate in a recent post by one of our developers. As a non-technical member of the team, I wanted to learn what Turing completeness actually means, why the blockchain community seems to be divided on the matter, and why our engineers are working hard to educate others on its drawbacks for safe smart contract programming.",
            "menu": "Turing Completeness and Smart Contract Security",
            "label": "Turing Completeness and Smart Contract Security",
            "publishDate": "2019-02-11T00:00:00.000Z",
            "headerImage": "/assets/blog/1_c2IEMI9RU0GCsulsUkl-8w.webp",
            "tags": [
              "smart contract",
              "pact"
            ],
            "author": "Taylor Rolfe",
            "authorId": "taylor.rolfe",
            "layout": "blog",
            "wordCount": 1389,
            "readingTimeInMinutes": 7,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/uscf-collaborates-with-kadena-on-use-of-blockchain-in-the-investment-space-2019-05-13",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "USCF Collaborates with Kadena on Use of Blockchain in Investment Space",
            "description": "US Commodities Fund Investments (USCF), a leading and innovative provider of commodities and alternative investment products, today announced that it is collaborating with Kadena, the first blockchain technology company to come out of JP Morgan’s Blockchain Center for Excellence.",
            "menu": "USCF Collaborates with Kadena on Use of Blockchain in Investment Space",
            "label": "USCF Collaborates with Kadena on Use of Blockchain in Investment Space",
            "publishDate": "2019-05-13T00:00:00.000Z",
            "headerImage": "/assets/blog/1_0s4RpYfueV_4QldpVe3a2A.webp",
            "tags": [
              "kadena"
            ],
            "author": "Tony Pham",
            "authorId": "tony.pham",
            "layout": "blog",
            "wordCount": 534,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/users-shouldnt-pay-for-gas-2019-12-19",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Users Shouldn’t Pay for Gas",
            "description": "The biggest impediment to the broad adoption of decentralized applications (dApps) is the requirement that participants onboard to a cryptocurrency first. As a consequence, interested parties often do not adopt because the ‘sign up’ or ‘create an account’ flow involves learning about wallets and keys. Then, participants find that they need to purchase tokens to pay for gas, which leads them to try to understand exchanges. By this point, it is understandable why the average participant already wants to give up. Overall, the contemporary dApp user journey is closer to about as painful as opening a bank account when it needs to be as simple as signing up for Instagram.",
            "menu": "Users Shouldn’t Pay for Gas",
            "label": "Users Shouldn’t Pay for Gas",
            "publishDate": "2019-12-19T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_2tCoP7nddaQefAs0TVlygg.webp",
            "tags": [
              "pact"
            ],
            "author": "Will Martino",
            "authorId": "will.martino",
            "layout": "blog",
            "wordCount": 1403,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/why-mining-private-blockchains-dont-mix-2019-02-06",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Why Mining & Private Blockchains Don’t Mix",
            "description": "On the difference between public and private blockchains. Bitcoin’s mining mechanism is a masterstroke of algorithmic design, enabling a scalable Byzantine Fault Tolerant (BFT) consensus by achieving a specific balance of incentives. As a reminder, mining-based blockchains like Bitcoin are public anyone can become a miner simply by downloading the software and firing it up.",
            "menu": "Why Mining & Private Blockchains Don’t Mix",
            "label": "Why Mining & Private Blockchains Don’t Mix",
            "publishDate": "2019-02-06T00:00:00.000Z",
            "author": "Will Martino",
            "authorId": "will.martino",
            "layout": "blog",
            "wordCount": 1962,
            "readingTimeInMinutes": 10,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2019/will-martino-explores-the-security-of-smart-contracts-2019-12-23",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Will Martino Explores the Security of Smart Contracts",
            "description": "This past June, Kadena Founder and CEO, Will Martino, was invited to speak at Consensus 2019. While speaking on the panel on ‘Why Blockchain Privacy Matters to the Enterprise,’ Will discussed the benefits of a hybrid blockchain platform and smart contract technology.",
            "menu": "Will Martino Explores the Security of Smart Contracts",
            "label": "Will Martino Explores the Security of Smart Contracts",
            "publishDate": "2019-12-23T00:00:00.000Z",
            "headerImage": "/assets/blog/2019/1_etPC4GFJ1YN9Ik3mlmp1dQ.webp",
            "tags": [
              "smart contract"
            ],
            "author": "Rebecca Rodriguez",
            "authorId": "rebecca.rodriguez",
            "layout": "blog",
            "wordCount": 527,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/blogchain/2019",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "BlogChain 2019",
        "menu": "2019",
        "subTitle": "2019",
        "label": "2019",
        "order": 3,
        "description": "articles..articles...articles 2019",
        "layout": "home",
        "wordCount": 143,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      },
      {
        "children": [
          {
            "children": [],
            "root": "/docs/blogchain/2018/blockchain-future-smart-contract-sharing-economy-2018-12-17",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The Future of Blockchain is the Smart Contract Sharing Economy",
            "description": "How Kadena’s stack turns cost centers into revenue generators. Kadena is uniquely positioned in the blockchain ecosystem; we provide a complete blockchain stack allowing entrepreneurs and developers to use both permissioned and permission-less (private and public) blockchains to unlock new sources of revenue.",
            "menu": "The Future of Blockchain is the Smart Contract Sharing Economy",
            "label": "The Future of Blockchain is the Smart Contract Sharing Economy",
            "publishDate": "2018-12-17T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Will Martino",
            "authorId": "will.martino",
            "layout": "blog",
            "wordCount": 1760,
            "readingTimeInMinutes": 9,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2018/consensus2018-5-lessons-from-your-first-crypto-conference-day-1-2018-04-15",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Consensus2018 5 Lessons from Your First Crypto Conference (Day 1)",
            "description": "What to do when they bring the lambos to your doorstep",
            "menu": "Consensus2018",
            "label": "Consensus2018",
            "publishDate": "2018-05-04T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 260,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2018/kadena-raises-12m-for-public-blockchain-2018-04-12",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena Raises $12M For Public Blockchain",
            "description": "Kadena is excited to announce that we’ve raised $12M in our second SAFT round, accelerating the development of our revolutionary public blockchain, Chainweb, aimed to be the fastest, safest, and most scalable proof-of-work consensus protocol out there. Check out the breaking coverage on CoinDesk.",
            "menu": "Kadena Raises $12M For Public Blockchain",
            "label": "Kadena Raises $12M For Public Blockchain",
            "publishDate": "2018-04-12T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 717,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2018/kadena-san-francisco-blockchain-week-2018-09-28",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "San Francisco Blockchain Week",
            "description": "Kadena is excited to be a part of San Francisco Blockchain Week! We start off our week with our SFBW Kick Off Party (co-hosted with MetalPay) at Coin-Op San Francisco on Sunday, October 7th. We’ve rented out the entire upstairs of Flynn Bar featuring arcade games, an open bar, and music all ready for us to have a good time. You can RSVP to the event here.",
            "menu": "San Francisco Blockchain Week",
            "label": "San Francisco Blockchain Week",
            "publishDate": "2018-09-28T00:00:00.000Z",
            "headerImage": "/assets/blog/1_ecJ400MzdFVrsqfd-EucJg.webp",
            "tags": [
              "kadena"
            ],
            "author": "Miguel Angel Romero Jr.",
            "authorId": "miguel.angel",
            "layout": "blog",
            "wordCount": 439,
            "readingTimeInMinutes": 3,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2018/pact-2-3-8-is-out-2018-04-09",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact 2.3.8 is out!",
            "description": "The latest version of Kadena’s smart-contract language, Pact 2.3.8, is released! This update boasts auto-completion and full readline support for the pact command line interpreter, no more rlwrap required. Hit tab to see all completions, up-arrow and down-arrow for history, Ctrl-A for beginning of line, Ctrl-E for end, etc. All made possible in record time by the incomparable Joel Burget.",
            "menu": "Pact 2.3.8 is out!",
            "label": "Pact 2.3.8 is out!",
            "publishDate": "2018-04-12T00:00:00.000Z",
            "tags": [
              "pact"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 360,
            "readingTimeInMinutes": 2,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2018/pact-2-4-is-out-2018-06-04",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact 2.4 Is Out!",
            "description": "After a lot of hard work we’re releasing the biggest pact upgrade since last year. Pact 2.4 brings some very significant changes to further establish Pact as the premier smart contracts language for blockchain formal verification that can be used by the average developer, right in their smart contract code; and a new dependency-management system we like to call “no left-pad”.",
            "menu": "Pact 2.4 Is Out!",
            "label": "Pact 2.4 Is Out!",
            "publishDate": "2018-06-04T00:00:00.000Z",
            "tags": [
              "pact"
            ],
            "author": "Stuart Popejoy",
            "authorId": "stuart.popejoy",
            "layout": "blog",
            "wordCount": 829,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2018/pact-formal-verification-for-blockchain-smart-contracts-done-right-2018-05-11",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Pact Formal Verification Making Blockchain Smart Contracts Safer",
            "description": "Property checking tools are now available for Kadena’s smart contract language, Pact! This means that Pact now allows for smart contract authors to express, automatically check, and formally verify that their code does not contain potentially catastrophic bugs.",
            "menu": "Pact Formal Verification",
            "label": "Pact Formal Verification",
            "publishDate": "2018-05-11T00:00:00.000Z",
            "tags": [
              "pact",
              "formal verification"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 1494,
            "readingTimeInMinutes": 8,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2018/security-kadena-chainweb-blockchain-2018-11-01",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Security in Kadena’s Public Blockchain",
            "description": "As awareness of Kadena and our blockchain protocol Chainweb grows, I see the same misunderstandings about how braided Proof of Work (PoW) functions, leading to repeated earnest but incorrect critiques. This issue is understandable as scalability research and analysis is still in its infancy, and we are still inventing a shared language for describing Byzantine Fault Tolerant (BFT) at scale systems.",
            "menu": "Security in Kadena’s Public Blockchain",
            "label": "Security in Kadena’s Public Blockchain",
            "publishDate": "2018-11-01T00:00:00.000Z",
            "tags": [
              "kadena",
              "chainweb"
            ],
            "author": "Monica Quaintance",
            "authorId": "monica.quaintance",
            "layout": "blog",
            "wordCount": 2050,
            "readingTimeInMinutes": 11,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2018/the-evm-is-fundamentally-unsafe-2018-02-07",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Kadena The Next Generation Blockchain",
            "description": "Kadena has a lot of exciting news and updates about our company, its technology, and what’s on the horizon. We want to thank you all so much for your incredible enthusiasm and support! Here’s what’s gone down in the past few months",
            "menu": "Kadena The Next Generation Blockchain",
            "label": "Kadena The Next Generation Blockchain",
            "publishDate": "2018-02-07T00:00:00.000Z",
            "tags": [
              "kadena"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 784,
            "readingTimeInMinutes": 4,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2018/the-evm-is-fundamentally-unsafe-2018-12-13",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "The EVM Is Fundamentally Unsafe",
            "description": "An in-depth examination of the Ethereum Virtual Machine vs. Kadena’s Pact smart contract language",
            "menu": "The EVM Is Fundamentally Unsafe",
            "label": "The EVM Is Fundamentally Unsafe",
            "publishDate": "2018-12-14T00:00:00.000Z",
            "headerImage": "/assets/blog/1_zrqFVN1maTCedbz_OSl04Q.webp",
            "tags": [
              "kadena"
            ],
            "author": "Emily Pillmore",
            "authorId": "emily.pillmore",
            "layout": "blog",
            "wordCount": 2630,
            "readingTimeInMinutes": 14,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          },
          {
            "children": [],
            "root": "/docs/blogchain/2018/why-we-open-sourced-our-blockchains-smart-contract-language-2018-05-04",
            "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
            "title": "Why We Open-Sourced Our Blockchain’s Smart Contract Language",
            "description": "Back in November 2016, Kadena open-sourced our smart contract language, Pact™. Open-sourcing is all about empowering users, and that’s also what motivated us to make Pact in the first place––to empower people to enact meaningful events on a blockchain, safely and quickly. We believe open-source initiatives provide transparency and benefits to everyone",
            "menu": "Why We Open-Sourced Our Blockchain’s Smart Contract Language",
            "label": "Why We Open-Sourced Our Blockchain’s Smart Contract Language",
            "publishDate": "2018-05-04T00:00:00.000Z",
            "tags": [
              "smart contract",
              "pact",
              "oracles"
            ],
            "author": "Vivienne Chen",
            "authorId": "vivienne.chen",
            "layout": "blog",
            "wordCount": 890,
            "readingTimeInMinutes": 5,
            "isMenuOpen": false,
            "isActive": false,
            "isIndex": false
          }
        ],
        "root": "/docs/blogchain/2018",
        "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
        "title": "BlogChain 2018",
        "menu": "2018",
        "subTitle": "2018",
        "label": "2018",
        "order": 3,
        "description": "articles..articles...articles 2018",
        "layout": "home",
        "wordCount": 143,
        "readingTimeInMinutes": 1,
        "isMenuOpen": false,
        "isActive": false,
        "isIndex": true
      }
    ],
    "root": "/docs/blogchain",
    "lastModifiedDate": "Thu, 28 Sep 2023 14:00:59 GMT",
    "title": "BlogChain",
    "menu": "BlogChain",
    "subTitle": "The place where the blog meets the chain",
    "label": "BlogChain",
    "order": 7,
    "description": "The place where the blog meets the chain",
    "layout": "home",
    "wordCount": 281,
    "readingTimeInMinutes": 2,
    "isMenuOpen": false,
    "isActive": false,
    "isIndex": true
  }
]